<template>
  <div>
    <div class="gameLeft" v-if="lm">
      <div class="game_wrap" style>
        <div class="game_box tab_box">
          <div class="game_box_title" id="game_box_title">
            <ul id="numNavList" class="base-clear">
              <li :class="isSubNavActive(item, index) ? 'subBtn active' : 'subBtn'" v-for="(item, index) in subNavList"
                :key="index">
                <a @click="changeRoute(item.title)">{{ item.title }}</a>
              </li>
            </ul>
          </div>
          <div class="game_box_con">
            <div class="game_loading_wrap">
              <p>
                正在为您加载
                <span>请您稍后</span>
              </p>
              <p class="game_loding"></p>
            </div>

            <div class="game_item_warp">
              <div id="gameBox" class="game_item" style="display: block;">
                <div class="game_ball_wrap game_item_wrap base-clear">
                  <div class="game_box game_box_zhixuan col_1 gameBox base-clear" v-for="(group, groupIndex) in lmOddsGroups"
                    :key="group.title">
                    <div class="game_con">
                      <fieldset>
                        <legend>{{ group.title }}</legend>
                        <ul>
                          <li :data-sort="item.__sort" :data-title="group.title" :data-name="item.number"
                            v-for="(item, index) in group.items" :key="item.number || index">
                            <span class="name lm_name">{{ item.__name }}</span>
                            <span class="p">
                              <a class="oddsEvent" title="点击下注"
                                style="display: flex; justify-content: center; align-items: center;"
                                href="javascript:;">{{ formatPeilv(item.peilv) }}</a>
                            </span>
                            <span class="in">
                              <input class="input onlyNum orderInput" type="text" maxlength="7"
                                :data-number="item.number" />
                            </span>
                          </li>
                        </ul>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>
              <div class="game_tips_box">
                <div class="game_tips_bg"></div>
                <span class="tipsText"></span>
              </div>
            </div>

            <div id="gameBoxTool" class="game_box_tool base-clear" style="display: block !important;">
              <div class="tool_left">
                <div id="tool_ys_wrap" class="t_left">
                  <label for="tool_ys_input">快捷下注金额：</label>
                  <input v-model="yzdMoney" id="tool_ys_input" class="input onlyNum" maxlength="5" type="text" />
                  <i id="close" style="display: none;">x</i>
                  <span>
                    <a href="javascript:void(0)">50</a>
                    <a href="javascript:void(0)">100</a>
                    <a href="javascript:void(0)">200</a>
                    <a href="javascript:void(0)">500</a>
                    <a href="javascript:void(0)">1000</a>
                  </span>
                  <em>
                    <b>+</b>
                    <strong>
                      <input class="input onlyNum" type="text" />
                      <input class="input onlyNum" type="text" />
                      <input class="input onlyNum" type="text" />
                      <input class="input onlyNum" type="text" />
                      <input class="input onlyNum" type="text" />
                      <div class="base-clear"></div>
                      <input class="btn" type="button" value="确定" />
                    </strong>
                  </em>
                </div>
              </div>
              <div class="t_right">
                <input class="btn grayBtn" type="button" value="全选" @click="selectAllBalls('lm')" />
                <input id="clearBtn" class="btn grayBtn" type="button" value="重填" />
                <input id="gameSubmit" class="btn hotBtn disSubmit yzdtj" type="button" value="提交" @click="yzdHd()" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="gameLeft" v-if="ft">
      <div class="game_wrap" style>
        <div class="game_box tab_box">
          <div class="game_box_title" id="game_box_title">
            <ul id="numNavList" class="base-clear">
              <li :class="isSubNavActive(item, index) ? 'subBtn active' : 'subBtn'" v-for="(item, index) in subNavList"
                :key="index">
                <a @click="changeRoute(item.title)">{{ item.title }}</a>
              </li>
            </ul>
          </div>
          <div class="game_box_con ft_box_con">
            <div class="game_loading_wrap">
              <p>
                正在为您加载
                <span>请您稍后</span>
              </p>
              <p class="game_loding"></p>
            </div>

            <div class="game_item_warp">
              <div id="gameBox" class="game_item" style="display: block;">
                <div class="fant-page fant-content">
                  <table class="ft_table"  width="100%" cellpadding="0" cellspacing="0">
                    <tbody>
                      <tr>
                        <td v-for="label in ftRows[0]" :key="label" :class="ftCellClass(label)">
                          <li :data-sort="ftCell(label).__sort" data-title="番摊" :data-name="label">
                            <div>
                              <span class="name">{{ label }}</span><br />
                              <span class="p"><a class="oddsEvent" title="点击下注" href="javascript:;">{{ formatPeilv(ftCell(label).peilv) }}</a></span>
                            </div>
                            <span class="in"><input class="input onlyNum orderInput" type="text" maxlength="7" :data-number="ftCell(label).number" /></span>
                          </li>
                        </td>
                      </tr>
                      <tr>
                        <td v-for="label in ftRows[1].left" :key="label" :class="ftCellClass(label)">
                          <li :data-sort="ftCell(label).__sort" data-title="番摊" :data-name="label">
                            <div>
                              <span class="name">{{ label }}</span><br />
                              <span class="p"><a class="oddsEvent" title="点击下注" href="javascript:;">{{ formatPeilv(ftCell(label).peilv) }}</a></span>
                            </div>
                            <span class="in"><input class="input onlyNum orderInput" type="text" maxlength="7" :data-number="ftCell(label).number" /></span>
                          </li>
                        </td>
                        <td colspan="3" rowspan="3" class="ft_center_cell">
                          <table class="ft_inner_table" width="100%" cellspacing="0" cellpadding="0">
                            <tbody>
                              <tr>
                                <td width="25%"></td>
                                <td width="50%" :class="ftCellClass('1番')">
                                  <li :data-sort="ftCell('1番').__sort" data-title="番摊" data-name="1番">
                                    <div>
                                      <span class="name">1番</span><br />
                                      <span class="p"><a class="oddsEvent" title="点击下注" href="javascript:;">{{ formatPeilv(ftCell('1番').peilv) }}</a></span>
                                    </div>
                                    <span class="in"><input class="input onlyNum orderInput" type="text" maxlength="7" :data-number="ftCell('1番').number" /></span>
                                  </li>
                                </td>
                                <td width="25%"></td>
                              </tr>
                              <tr>
                                <td :class="ftCellClass('2番')">
                                  <li :data-sort="ftCell('2番').__sort" data-title="番摊" data-name="2番">
                                    <div>
                                      <span class="name">2番</span><br />
                                      <span class="p"><a class="oddsEvent" title="点击下注" href="javascript:;">{{ formatPeilv(ftCell('2番').peilv) }}</a></span>
                                    </div>
                                    <span class="in"><input class="input onlyNum orderInput" type="text" maxlength="7" :data-number="ftCell('2番').number" /></span>
                                  </li>
                                </td>
                                <td>
                                  <div class="ft_center">
                                    <div class="ft_center_item" :class="ftCellClass(label)" v-for="label in ['番单', '番双']" :key="label">
                                      <li :data-sort="ftCell(label).__sort" data-title="番摊" :data-name="label">
                                        <span class="name">{{ label.replace('番', '') }}</span>
                                        <span class="p"><a class="oddsEvent" title="点击下注" href="javascript:;">{{ formatPeilv(ftCell(label).peilv) }}</a></span><br />
                                        <span class="in"><input class="input onlyNum orderInput" type="text" maxlength="7" :data-number="ftCell(label).number" /></span>
                                      </li>
                                    </div>
                                  </div>
                                  <div class="ft_center">
                                    <div class="ft_center_item" :class="ftCellClass(label)" v-for="label in ['番大', '番小']" :key="label">
                                      <li :data-sort="ftCell(label).__sort" data-title="番摊" :data-name="label">
                                        <span class="name">{{ label.replace('番', '') }}</span>
                                        <span class="p"><a class="oddsEvent" title="点击下注" href="javascript:;">{{ formatPeilv(ftCell(label).peilv) }}</a></span><br />
                                        <span class="in"><input class="input onlyNum orderInput" type="text" maxlength="7" :data-number="ftCell(label).number" /></span>
                                      </li>
                                    </div>
                                  </div>
                                </td>
                                <td :class="ftCellClass('4番')">
                                  <li :data-sort="ftCell('4番').__sort" data-title="番摊" data-name="4番">
                                    <div>
                                      <span class="name">4番</span><br />
                                      <span class="p"><a class="oddsEvent" title="点击下注" href="javascript:;">{{ formatPeilv(ftCell('4番').peilv) }}</a></span>
                                    </div>
                                    <span class="in"><input class="input onlyNum orderInput" type="text" maxlength="7" :data-number="ftCell('4番').number" /></span>
                                  </li>
                                </td>
                              </tr>
                              <tr>
                                <td></td>
                                <td :class="ftCellClass('3番')">
                                  <li :data-sort="ftCell('3番').__sort" data-title="番摊" data-name="3番">
                                    <div>
                                      <span class="name">3番</span><br />
                                      <span class="p"><a class="oddsEvent" title="点击下注" href="javascript:;">{{ formatPeilv(ftCell('3番').peilv) }}</a></span>
                                    </div>
                                    <span class="in"><input class="input onlyNum orderInput" type="text" maxlength="7" :data-number="ftCell('3番').number" /></span>
                                  </li>
                                </td>
                                <td></td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td :class="ftCellClass(ftRows[1].right)">
                          <li :data-sort="ftCell(ftRows[1].right).__sort" data-title="番摊" :data-name="ftRows[1].right">
                            <div>
                              <span class="name">{{ ftRows[1].right }}</span><br />
                              <span class="p"><a class="oddsEvent" title="点击下注" href="javascript:;">{{ formatPeilv(ftCell(ftRows[1].right).peilv) }}</a></span>
                            </div>
                            <span class="in"><input class="input onlyNum orderInput" type="text" maxlength="7" :data-number="ftCell(ftRows[1].right).number" /></span>
                          </li>
                        </td>
                      </tr>
                      <tr v-for="row in ftRows.slice(2, 4)" :key="row.left.join('-')">
                        <td v-for="label in row.left" :key="label" :class="ftCellClass(label)">
                          <li :data-sort="ftCell(label).__sort" data-title="番摊" :data-name="label">
                            <div>
                              <span class="name">{{ label }}</span><br />
                              <span class="p"><a class="oddsEvent" title="点击下注" href="javascript:;">{{ formatPeilv(ftCell(label).peilv) }}</a></span>
                            </div>
                            <span class="in"><input class="input onlyNum orderInput" type="text" maxlength="7" :data-number="ftCell(label).number" /></span>
                          </li>
                        </td>
                        <td :class="ftCellClass(row.right)">
                          <li :data-sort="ftCell(row.right).__sort" data-title="番摊" :data-name="row.right">
                            <div>
                              <span class="name">{{ row.right }}</span><br />
                              <span class="p"><a class="oddsEvent" title="点击下注" href="javascript:;">{{ formatPeilv(ftCell(row.right).peilv) }}</a></span>
                            </div>
                            <span class="in"><input class="input onlyNum orderInput" type="text" maxlength="7" :data-number="ftCell(row.right).number" /></span>
                          </li>
                        </td>
                      </tr>
                      <tr>
                        <td v-for="label in ftRows[4]" :key="label" :class="ftCellClass(label)">
                          <li :data-sort="ftCell(label).__sort" data-title="番摊" :data-name="label">
                            <div>
                              <span class="name">{{ label }}</span><br />
                              <span class="p"><a class="oddsEvent" title="点击下注" href="javascript:;">{{ formatPeilv(ftCell(label).peilv) }}</a></span>
                            </div>
                            <span class="in"><input class="input onlyNum orderInput" type="text" maxlength="7" :data-number="ftCell(label).number" /></span>
                          </li>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="game_tips_box">
                <div class="game_tips_bg"></div>
                <span class="tipsText"></span>
              </div>
            </div>

            <div id="gameBoxTool" class="game_box_tool base-clear" style="display: block !important;">
              <div class="tool_left">
                <div id="tool_ys_wrap" class="t_left">
                  <label for="tool_ys_input">快捷下注金额：</label>
                  <input v-model="yzdMoney" id="tool_ys_input" class="input onlyNum" maxlength="7" type="text" />
                  <i id="close" style="display: none;">x</i>
                  <span>
                    <a href="javascript:void(0)">50</a>
                    <a href="javascript:void(0)">100</a>
                    <a href="javascript:void(0)">200</a>
                    <a href="javascript:void(0)">500</a>
                    <a href="javascript:void(0)">1000</a>
                  </span>
                  <em>
                    <b>+</b>
                    <strong>
                      <input class="input onlyNum" type="text" />
                      <input class="input onlyNum" type="text" />
                      <input class="input onlyNum" type="text" />
                      <input class="input onlyNum" type="text" />
                      <input class="input onlyNum" type="text" />
                      <div class="base-clear"></div>
                      <input class="btn" type="button" value="确定" />
                    </strong>
                  </em>
                </div>
              </div>
              <div class="t_right">
                <input class="btn grayBtn" type="button" value="全选" @click="selectAllBalls('ft')" />
                <input id="clearBtn" class="btn grayBtn" type="button" value="重填" />
                <input id="gameSubmit" class="btn hotBtn disSubmit yzdtj" type="button" value="提交" @click="yzdHd()" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="gameLeft" v-if="yzd">
      <div class="game_wrap" style>
        <div class="game_box tab_box">
          <div class="game_box_title" id="game_box_title">
            <ul id="numNavList" class="base-clear">
              <li :class="isSubNavActive(item, index) ? 'subBtn active' : 'subBtn'" v-for="(item, index) in subNavList"
                :key="index">
                <a @click="changeRoute(item.title)">{{ item.title }}</a>
              </li>
            </ul>
          </div>
          <div class="game_box_con">
            <div class="game_loading_wrap">
              <p>
                正在为您加载
                <span>请您稍后</span>
              </p>
              <p class="game_loding"></p>
            </div>

            <div class="game_item_warp">
              <div id="gameBox" class="game_item" style="display: block;">
                <div class="game_ball_wrap game_item_wrap base-clear">
                  <div class="game_box game_box_zhixuan col_1 gameBox base-clear">
                    <div class="game_con">
                      <fieldset>
                        <legend>第一球</legend>
                        <ul>
                          <li :data-sort="index + 1" data-title="第一球" :data-name="index"
                            v-for="(item, index) in d1wBallGroups[0]" :key="index">
                            <span class="name">
                              <i :class="'SSCNo_' + index"></i>
                            </span>
                            <span class="p">
                              <a class="oddsEvent" title="点击下注"
                                style="display: flex; justify-content: center; align-items: center;"
                                href="javascript:;">{{ formatOrderPeilv(item, 2) }}</a>
                            </span>
                            <span class="in">
                              <input class="input onlyNum orderInput" type="text" maxlength="7"
                                :data-number="item.number" />
                            </span>
                          </li>
                        </ul>
                        <div class="dsdx" style="width: 168px;text-align: center;display: inline-block;margin-top: 5px">
                          <a data-index="0" class="kxbtn" href="javascript:void(0)">单</a>
                          <a data-index="0" class="kxbtn" style="margin-left: 5px" href="javascript:void(0)">双</a>
                          <a data-index="0" class="kxbtn" style="margin-left: 5px" href="javascript:void(0)">大</a>
                          <a data-index="0" class="kxbtn" style="margin-left: 5px" href="javascript:void(0)">小</a>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div class="game_box col_1 gameBox base-clear">
                    <div class="game_con">
                      <fieldset>
                        <legend>第二球</legend>
                        <ul>
                          <li :data-sort="index + 1" data-title="第二球" :data-name="index"
                            v-for="(item, index) in d1wBallGroups[1]" :key="index">
                            <span class="name">
                              <i :class="'SSCNo_' + index"></i>
                            </span>
                            <span class="p">
                              <a class="oddsEvent" style="display: flex; justify-content: center; align-items: center;"
                                title="点击下注" href="javascript:;">{{ formatOrderPeilv(item, 2) }}</a>
                            </span>
                            <span class="in">
                              <input class="input onlyNum orderInput" type="text" maxlength="7"
                                :data-number="item.number" />
                            </span>
                          </li>
                        </ul>
                        <div class="dsdx" style="width: 168px;text-align: center;display: inline-block;margin-top: 5px">
                          <a data-index="1" class="kxbtn" href="javascript:void(0)">单</a>
                          <a data-index="1" class="kxbtn" style="margin-left: 5px" href="javascript:void(0)">双</a>
                          <a data-index="1" class="kxbtn" style="margin-left: 5px" href="javascript:void(0)">大</a>
                          <a data-index="1" class="kxbtn" style="margin-left: 5px" href="javascript:void(0)">小</a>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div class="game_box col_1 gameBox base-clear">
                    <div class="game_con">
                      <fieldset>
                        <legend>第三球</legend>
                        <ul>
                          <li :data-sort="index + 1" data-title="第三球" :data-name="index"
                            v-for="(item, index) in d1wBallGroups[2]" :key="index">
                            <span class="name">
                              <i :class="'SSCNo_' + index"></i>
                            </span>
                            <span class="p">
                              <a class="oddsEvent" style="display: flex; justify-content: center; align-items: center;"
                                title="点击下注" href="javascript:;">{{ formatOrderPeilv(item, 2) }}</a>
                            </span>
                            <span class="in">
                              <input class="input onlyNum orderInput" type="text" maxlength="7"
                                :data-number="item.number" />
                            </span>
                          </li>
                        </ul>
                        <div class="dsdx" style="width: 168px;text-align: center;display: inline-block;margin-top: 5px">
                          <a data-index="2" class="kxbtn" href="javascript:void(0)">单</a>
                          <a data-index="2" class="kxbtn" style="margin-left: 5px" href="javascript:void(0)">双</a>
                          <a data-index="2" class="kxbtn" style="margin-left: 5px" href="javascript:void(0)">大</a>
                          <a data-index="2" class="kxbtn" style="margin-left: 5px" href="javascript:void(0)">小</a>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div class="game_box col_1 gameBox base-clear" v-if="d1wBallGroups[3] && d1wBallGroups[3].length">
                    <div class="game_con">
                      <fieldset>
                        <legend>第四球</legend>
                        <ul>
                          <li :data-sort="index + 1" data-title="第四球" :data-name="index"
                            v-for="(item, index) in d1wBallGroups[3]" :key="index">
                            <span class="name">
                              <i :class="'SSCNo_' + index"></i>
                            </span>
                            <span class="p">
                              <a class="oddsEvent" style="display: flex; justify-content: center; align-items: center;"
                                title="点击下注" href="javascript:;">{{ formatOrderPeilv(item, 2) }}</a>
                            </span>
                            <span class="in">
                              <input class="input onlyNum orderInput" type="text" maxlength="7"
                                :data-number="item.number" />
                            </span>
                          </li>
                        </ul>
                        <div class="dsdx" style="width: 168px;text-align: center;display: inline-block;margin-top: 5px">
                          <a data-index="3" class="kxbtn" href="javascript:void(0)">单</a>
                          <a data-index="3" class="kxbtn" style="margin-left: 5px" href="javascript:void(0)">双</a>
                          <a data-index="3" class="kxbtn" style="margin-left: 5px" href="javascript:void(0)">大</a>
                          <a data-index="3" class="kxbtn" style="margin-left: 5px" href="javascript:void(0)">小</a>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div class="game_box col_1 gameBox base-clear" v-if="d1wBallGroups[4] && d1wBallGroups[4].length">
                    <div class="game_con">
                      <fieldset>
                        <legend>第五球</legend>
                        <ul>
                          <li :data-sort="index + 1" data-title="第五球" :data-name="index"
                            v-for="(item, index) in d1wBallGroups[4]" :key="index">
                            <span class="name">
                              <i :class="'SSCNo_' + index"></i>
                            </span>
                            <span class="p">
                              <a class="oddsEvent" style="display: flex; justify-content: center; align-items: center;"
                                title="点击下注" href="javascript:;">{{ formatOrderPeilv(item, 2) }}</a>
                            </span>
                            <span class="in">
                              <input class="input onlyNum orderInput" type="text" maxlength="7"
                                :data-number="item.number" />
                            </span>
                          </li>
                        </ul>
                        <div class="dsdx" style="width: 168px;text-align: center;display: inline-block;margin-top: 5px">
                          <a data-index="4" class="kxbtn" href="javascript:void(0)">单</a>
                          <a data-index="4" class="kxbtn" style="margin-left: 5px" href="javascript:void(0)">双</a>
                          <a data-index="4" class="kxbtn" style="margin-left: 5px" href="javascript:void(0)">大</a>
                          <a data-index="4" class="kxbtn" style="margin-left: 5px" href="javascript:void(0)">小</a>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>
              <div class="game_tips_box">
                <div class="game_tips_bg"></div>
                <span class="tipsText"></span>
              </div>
            </div>

            <!-- gameBoxTool start -->
            <div id="gameBoxTool" class="game_box_tool base-clear" style="display: block !important;">
              <div class="tool_left">
                <div id="tool_ys_wrap" class="t_left">
                  <label for="tool_ys_input">快捷下注金额：</label>
                  <input v-model="yzdMoney" id="tool_ys_input" class="input onlyNum" maxlength="5" type="text" />
                  <i id="close" style="display: none;">x</i>
                  <span>
                    <a href="javascript:void(0)">50</a>
                    <a href="javascript:void(0)">100</a>
                    <a href="javascript:void(0)">200</a>
                    <a href="javascript:void(0)">500</a>
                    <a href="javascript:void(0)">1000</a>
                  </span>
                  <em>
                    <b>+</b>
                    <strong>
                      <input class="input onlyNum" type="text" />
                      <input class="input onlyNum" type="text" />
                      <input class="input onlyNum" type="text" />
                      <input class="input onlyNum" type="text" />
                      <input class="input onlyNum" type="text" />
                      <div class="base-clear"></div>
                      <input class="btn" type="button" value="确定" />
                    </strong>
                  </em>
                </div>
              </div>
              <div class="t_right">
                <input id="clearBtn" class="btn grayBtn" type="button" value="重填" />
                <input id="gameSubmit" class="btn hotBtn disSubmit yzdtj" type="button" value="提交" @click="yzdHd()" />
              </div>
            </div>
            <!-- gameBoxTool end -->
          </div>
        </div>
      </div>

      <div id="hot_Cool" class="hot_Cool"></div>

      <!-- trend start -->
      <div id="cqlResult" class="trend_wrap tab_box"></div>
      <!-- trend end -->
    </div>

    <div class="gameLeft" v-if="ezd">
      <div class="game_wrap" style>
        <div class="game_box tab_box">
          <div class="game_box_title" id="game_box_title">
            <ul id="numNavList" class="base-clear">
              <li :class="isSubNavActive(item, index) ? 'subBtn active' : 'subBtn'" v-for="(item, index) in subNavList"
                :key="index">
                <a @click="changeRoute(item.title)">{{ item.title }}</a>
              </li>
            </ul>
          </div>
          <div class="game_box_con">
            <div class="game_loading_wrap">
              <p>
                正在为您加载
                <span>请您稍后</span>
              </p>
              <p class="game_loding"></p>
            </div>

            <div class="game_item_warp" style>
              <div id="gameBox" class="game_item game_box_zhixuan" style="display: block;">
                <div id="subNavList" class="game_box_tool2 base-clear">
                  <a href="javascript:void(0)" :data-action="'gamedata&gameIndex=3&type=' + -(-index - 9)"
                    :class="index == selectedIndex ? 'selected' : ''" v-for="(item, index) in ezdSubNavList"
                    :key="index" @click="changeEzdNav(index)">&nbsp;{{ item.title }}&nbsp;|</a>
                </div>
                <div class="game_ball_wrap game_item_wrap base-clear" style="padding-top: 30px;padding-left: 1px">
                  <div class="game_box col_1 base-clear" v-for="(column, columnIndex) in ezdColumnGroups"
                    :key="columnIndex">
                    <div :data-index="column.startSort" class="triangle-topleft"></div>
                    <div v-if="columnIndex == 0" style="float: left;margin-left: -8px">
                      <div v-for="(sideItem, sideIndex) in column.items" :key="sideIndex"
                        style="height: 31px;position: relative;text-align: center">
                        <div :data-index="sideItem.__sort" class="triangle-right"></div>
                      </div>
                    </div>
                    <div class="game_con" style="width: 174px">
                      <fieldset>
                        <ul>
                          <li :data-sort="item.__sort" :data-title="currentEzdTitle()" :data-name="item.number"
                            v-for="(item, index) in column.items" :key="index">
                            <span class="name bf_12"
                              style="width: 33px;display: flex; justify-content: center; align-items: center;">{{
                              item.number }}</span>
                            <span class="p">
                              <a class="oddsEvent" style="display: flex; justify-content: center; align-items: center;"
                                title="点击下注">{{ formatOrderPeilv(item, 1) }}</a>
                            </span>
                            <span class="in">
                              <input class="input onlyNum orderInput" :data-number="item.number" type="text"
                                maxlength="7" />
                            </span>
                          </li>
                        </ul>
                      </fieldset>
                    </div>
                  </div>
                  <table class="t_dw" id="bd_fix">
                    <tbody>
                      <tr>
                        <td width="100%">
                          <table class="t_dw">
                            <tbody>
                              <tr>
                                <td rowspan="2" style="text-align: center" width="50">定位置</td>
                                <td class="fn-fix" id="fix_1" style="padding-left: 5px">
                                  {{ currentEzdPosName(0) }}
                                  <a class="kxbtn" style="margin-left: 2px" name="0">0</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="1">1</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="2">2</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="3">3</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="4">4</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="5">5</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="6">6</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="7">7</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="8">8</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="9">9</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="10">单</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="11">双</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="12">大</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="13">小</a>
                                </td>
                                <td rowspan="2" style="text-align: center" width="40">合分</td>
                                <td rowspan="2" class="fn-hf" id="fn-hf">
                                  <div style="margin-left: 5px">
                                    <a class="kxbtn" style="margin-left: 2px" name="0">0</a>
                                    <a class="kxbtn" style="margin-left: 2px" name="1">1</a>
                                    <a class="kxbtn" style="margin-left: 2px" name="2">2</a>
                                    <a class="kxbtn" style="margin-left: 2px" name="3">3</a>
                                    <a class="kxbtn" style="margin-left: 2px" name="4">4</a>
                                    <a class="kxbtn" style="margin-left: 2px" name="10">单</a>
                                  </div>
                                  <div style="margin-left: 5px">
                                    <a class="kxbtn" style="margin-left: 2px" name="5">5</a>
                                    <a class="kxbtn" style="margin-left: 2px" name="6">6</a>
                                    <a class="kxbtn" style="margin-left: 2px" name="7">7</a>
                                    <a class="kxbtn" style="margin-left: 2px" name="8">8</a>
                                    <a class="kxbtn" style="margin-left: 2px" name="9">9</a>
                                    <a class="kxbtn" style="margin-left: 2px" name="11">双</a>
                                  </div>
                                </td>
                                <td>
                                  <span style="margin-left: 5px">{{ currentEzdPosLabel(0) }}</span>
                                  <input id="ipdw_1" type="number" index="1" />
                                </td>
                              </tr>
                              <tr>
                                <td class="fn-fix" id="fix_2" style="padding-left: 5px">
                                  {{ currentEzdPosName(1) }}
                                  <a class="kxbtn" style="margin-left: 2px" name="0">0</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="1">1</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="2">2</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="3">3</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="4">4</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="5">5</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="6">6</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="7">7</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="8">8</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="9">9</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="10">单</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="11">双</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="12">大</a>
                                  <a class="kxbtn" style="margin-left: 2px" name="13">小</a>
                                </td>
                                <td>
                                  <span style="margin-left: 5px">{{ currentEzdPosLabel(1) }}</span>
                                  <input id="ipdw_2" type="number" index="2" />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="game_tips_box">
                <div class="game_tips_bg"></div>
                <span class="tipsText"></span>
              </div>
            </div>

            <!-- gameBoxTool start -->
            <div id="gameBoxTool" class="game_box_tool base-clear" style="display: block !important;">
              <div class="tool_left">
                <div id="tool_ys_wrap" class="t_left">
                  <label for="tool_ys_input">快捷下注金额：</label>
                  <input v-model="ezdMoney" id="tool_ys_input" class="input onlyNum" maxlength="5" type="text" />
                  <i id="close" style="display: none;">x</i>
                  <span>
                    <a href="javascript:void(0)">50</a>
                    <a href="javascript:void(0)">100</a>
                    <a href="javascript:void(0)">200</a>
                    <a href="javascript:void(0)">500</a>
                    <a href="javascript:void(0)">1000</a>
                  </span>
                  <em>
                    <b>+</b>
                    <strong>
                      <input class="input onlyNum" type="text" />
                      <input class="input onlyNum" type="text" />
                      <input class="input onlyNum" type="text" />
                      <input class="input onlyNum" type="text" />
                      <input class="input onlyNum" type="text" />
                      <div class="base-clear"></div>
                      <input class="btn" type="button" value="确定" />
                    </strong>
                  </em>
                </div>
              </div>
              <div class="t_right">
                <input id="clearBtn" class="btn grayBtn" type="button" value="重填" />
                <input id="gameSubmit" class="btn hotBtn disSubmit btn hotBtn disSubmit" type="button" value="提交"
                  @click="yzdHd()" />
              </div>
            </div>
            <!-- gameBoxTool end -->
          </div>
        </div>
      </div>

      <div id="hot_Cool" class="hot_Cool"></div>

      <!-- trend start -->
      <div id="cqlResult" class="trend_wrap tab_box"></div>
      <!-- trend end -->
    </div>

    <div class="gameLeft" v-if="kd">
      <div class="game_wrap" style>
        <div class="game_box tab_box">
          <div class="game_box_title" id="game_box_title">
            <ul id="numNavList" class="base-clear">
              <li :class="isSubNavActive(item, index) ? 'subBtn active' : 'subBtn'" v-for="(item, index) in subNavList"
                :key="index">
                <a @click="changeRoute(item.title)">{{ item.title }}</a>
              </li>
            </ul>
          </div>
          <div class="game_box_con">
            <div class="game_loading_wrap">
              <p>
                正在为您加载
                <span>请您稍后</span>
              </p>
              <p class="game_loding"></p>
            </div>

            <div class="game_item_warp" style>
              <div id="gameBox" class="game_item" style="display: block;">
                <div class="t_1">
                  <div class="history_wrap">
                    <table>
                      <thead>
                        <tr>
                          <th width="10%">彩种</th>
                          <th width="20%">注单编号</th>
                          <th width="10%">号码</th>
                          <th width="9%">赔率</th>
                          <th width="9%">金额</th>
                          <th width="9%">回水</th>
                          <th width="9%">状态</th>
                          <th width="10%">
                            全选
                            <input v-model="kdQX" id="quanxian" type="checkbox" />
                            <input @click="kdChargeback()" id="tuima" type="button" value="退码" />
                          </th>
                        </tr>
                      </thead>

                      <tbody id="betList" v-if="kdList.length == 0">
                        <tr v-for="(item, index) in 10" :key="index">
                          <td v-for="(item, index) in 8" :key="index">--</td>
                        </tr>
                      </tbody>
                      <tbody v-else-if="kdList.length <= 10" id="betList">
                        <tr v-for="(item, index) in kdList" :key="item.orderId || index" :class="[item.ispei == 2 ? 'charge' : '']">
                          <!-- <td>{{item.gameCode | gameCodeFormate}}</td> -->
                          <td>{{ currentGameName }}</td>
                          <td>{{ item.orderId }}</td>
                          <td>{{ item.betNumber }}</td>
                          <td>{{ formatOrderPeilv(item, 1) }}</td>
                          <td>{{ (item.money * 1).toFixed(2) }}</td>
                          <td>{{ item.back }}</td>
                          <td>{{ item.ispei == '-' ? '-' : (item.ispei == 0 ? '成功' : item.ispei == 1 ? '已赔' : item.ispei
                            == 2
                            ? '退码' :item.ispei ==3 ?'停码':'和')}}</td>
                          <td>
                            <span v-if="item.ispei == 2">--</span>
                            <input v-else v-model="item.checked" type="checkbox" name id />
                          </td>
                        </tr>
                        <tr v-for="(item, index) in (10 - kdList.length)" :key="item">
                          <td v-for="(item, index) in 8" :key="index">--</td>
                        </tr>
                      </tbody>
                      <tbody v-else id="betList">
                        <tr v-for="(item, index) in kdList.slice(0, 10)" :class="[item.ispei == 2 ? 'charge' : '']"
                          :key="item.orderId || index">
                          <!-- <td>{{item.gameCode | gameCodeFormate}}</td> -->
                          <td>{{ currentGameName }}</td>
                          <td>{{ item.orderId }}</td>
                          <td>{{ item.betNumber }}</td>
                          <td>{{ formatOrderPeilv(item, 1) }}</td>
                          <td>{{ (item.money * 1).toFixed(2) }}</td>
                          <td>{{ item.back }}</td>
                          <td>{{ item.ispei == '-' ? '-' : (item.ispei == 0 ? '成功' : item.ispei == 1 ? '已赔' : item.ispei
                            == 2
                            ? '退码' :item.ispei ==3 ?'停码':'和')}}</td>
                          <td>
                            <span v-if="item.ispei == 2">--</span>
                            <input v-else v-model="item.checked" type="checkbox" name id />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="game_tips_box">
                <div class="game_tips_bg"></div>
                <span class="tipsText"></span>
              </div>
            </div>

            <!-- gameBoxTool start -->
            <div id="gameBoxTool" class="game_box_tool base-clear" style="display: block !important;">
              <div class="tool_left">
                <div id="tool_ys_wrap" class="t_left">
                  <label for="tool_hm_input">号码：</label>
                  <input id="tool_hm_input" placeholder="x=X" class="input" maxlength="5"
                    type="text" />&nbsp;&nbsp;&nbsp;&nbsp;
                  <label for="tool_ys_input">下注金额：</label>
                  <input id="tool_ys_input" @keyup.enter="kdtj" oninput="value=value.replace(/[^\d]/g,'')"
                    class="input onlyNum" maxlength="5" type="text" />&nbsp;&nbsp;
                  <input id="fastSubmit" class="btn hotBtn disSubmit" type="button" @click="kdtj"
                    value="提交" />&nbsp;&nbsp;
                  <label id="oddsmoney"></label>
                </div>
              </div>
            </div>
            <!-- gameBoxTool end -->
          </div>
        </div>
      </div>

      <div id="hot_Cool" class="hot_Cool"></div>

      <!-- trend start -->
      <div id="cqlResult" class="trend_wrap tab_box"></div>
      <!-- trend end -->
    </div>

    <div class="gameLeft" v-if="kx" style="width: 600px">
      <div class="game_wrap" style="width: 600px">
        <div class="game_box tab_box">
          <div class="game_box_title" id="game_box_title">
            <ul id="numNavList" class="base-clear">
              <li :class="isSubNavActive(item, index) ? 'subBtn active' : 'subBtn'" v-for="(item, index) in subNavList"
                :key="index">
                <a @click="changeRoute(item.title)">{{ item.title }}</a>
              </li>
            </ul>
          </div>
          <div class="game_box_con">
            <div class="game_loading_wrap">
              <p>
                正在为您加载
                <span>请您稍后</span>
              </p>
              <p class="game_loding"></p>
            </div>

            <div class="game_item_warp" style="width: 600px;">
              <div id="gameBox" class="game_item" style="display: block;">
                <div class="t_1" style="max-height: 500px;min-height: 370px">
                  <span id="kxlog" style="display: none"></span>
                  <div id="kxnumbers" class="history_wrap"
                    style="max-height: 500px;min-height: 370px;overflow-y: auto;"></div>
                </div>
              </div>
              <div class="game_tips_box">
                <div class="game_tips_bg"></div>
                <span class="tipsText"></span>
              </div>
            </div>

            <!-- gameBoxTool start -->
            <div id="gameBoxTool" class="game_box_tool base-clear"
              style="width: 578px;min-width: 578px; display: block !important;">
              <div class="tool_left">
                <div id="tool_ys_wrap" class="t_left">
                  <label for="tool_ys_input">下注金额：</label>
                  <input id="tool_ys_input" class="input onlyNum" maxlength="5" type="text" />&nbsp;&nbsp;
                  <input id="kxSubmit" class="btn hotBtn disSubmit" type="button" value="提交" /> &nbsp;&nbsp;笔数：
                  <span id="zbishu" style="color: #ff0000"></span> &nbsp;&nbsp;金额：
                  <span id="zmoney" style="color: #ff0000"></span>
                </div>
              </div>
            </div>
            <!-- gameBoxTool end -->
          </div>
        </div>
      </div>

      <div id="hot_Cool" class="hot_Cool"></div>

      <!-- trend start -->
      <div id="cqlResult" class="trend_wrap tab_box"></div>
      <!-- trend end -->
    </div>

    <div class="gameLeft" v-if="txtdr" style="width: 900px">
      <div class="game_wrap" style="width: 900px">
        <div class="game_box tab_box">
          <div class="game_box_title" id="game_box_title">
            <ul id="numNavList" class="base-clear">
              <li :class="isSubNavActive(item, index) ? 'subBtn active' : 'subBtn'" v-for="(item, index) in subNavList"
                :key="index">
                <a @click="changeRoute(item.title)">{{ item.title }}</a>
              </li>
            </ul>
          </div>
          <div class="game_box_con">
            <div class="game_loading_wrap">
              <p>
                正在为您加载
                <span>请您稍后</span>
              </p>
              <p class="game_loding"></p>
            </div>

            <div class="game_item_warp" style="width: 900px">
              <div id="gameBox" class="game_item" style="display: block;">
                <div class="t_1" style="max-height: 500px;min-height: 370px">
                  <div id="txtnumbers" class="history_wrap" style="max-height: 500px;min-height: 370px;overflow: auto;">
                    <div>
                      <strong>&nbsp;&nbsp;格式A：</strong>号码，号码，号码&nbsp;&nbsp;&nbsp;&nbsp;
                      <strong>格式B：</strong>号码=金额，号码=金额，号码=金额
                      <span class="red">(逗号也可以用空格代表)</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    </div>
                    <br />
                    <div>
                      &nbsp;&nbsp;说明：由于各会员使用的（txt文件）的格式不一样，如果不符合网站上要求的格式，有可能导入到网站（没有下注之前）的号码内容和自己（txt文件）里号码内容不一致，操作时请认真检查，如果出现内容不一致，请不要下注。
                    </div>
                  </div>
                </div>
              </div>
              <div class="game_tips_box">
                <div class="game_tips_bg"></div>
                <span class="tipsText"></span>
              </div>
            </div>

            <!-- gameBoxTool start -->
            <div id="gameBoxTool" class="game_box_tool base-clear"
              style="width: 878px;min-width: 878px; display: block !important;">
              <div class="tool_left">
                <div id="tool_ys_wrap" class="t_left">
                  <label for="tool_ys_input">下注金额：</label>
                  <input id="tool_ys_input" oninput="value=value.replace(/[^\d | ^.]/g,'')" class="input onlyNum"
                    maxlength="5" type="text" />&nbsp;&nbsp;
                  <input id="text" type="file" @change="changTxt()" />&nbsp;&nbsp;
                  <input id="kySubmit" class="btn hotBtn disSubmit" type="button" value="提交" /> &nbsp;&nbsp;笔数：
                  <span id="zbishu" style="color: #ff0000"></span> &nbsp;&nbsp;金额：
                  <span id="zmoney" style="color: #ff0000"></span>
                </div>
              </div>
            </div>
            <!-- gameBoxTool end -->
          </div>
        </div>
      </div>

      <div id="hot_Cool" class="hot_Cool"></div>

      <!-- trend start -->
      <div id="cqlResult" class="trend_wrap tab_box"></div>
      <!-- trend end -->
    </div>
    <!-- rightBox start -->
    <div id="rightBox" class="rightBox tab_box base-clear game_box_title t_1"
      style="margin-top: 30px;margin-left: 10px;width: auto; display: none" v-if="kx" @keydown.enter="createNumber()">
    </div>
    <!-- rightBox end -->

    <div class="gameLeft" v-if="zxdetails">
      <div class="game_wrap" style="width: auto">
        <div class="game_box tab_box">
          <div class="game_box_title" id="game_box_title">
            <ul id="numNavList" class="base-clear">
              <li :class="isSubNavActive(item, index) ? 'subBtn active' : 'subBtn'" v-for="(item, index) in subNavList"
                :key="index">
                <a @click="changeRoute(item.title)">{{ item.title }}</a>
              </li>
            </ul>
          </div>
          <div class="game_box_con">
            <div class="game_loading_wrap" style="width:1200px">
              <p>
                正在为您加载
                <span>请您稍后</span>
              </p>
              <p class="game_loding"></p>
            </div>

            <div class="game_item_warp" style="width: 1200px">
              <div id="gameBox" class="game_item" style="display: block;">
                <div class="shell-top" id="shell-top">
                  <div id="title-nav" style="margin-top: 5px">
                    &nbsp;&nbsp;
                    <label>
                      彩种:
                      <select name="gameIndex" v-model="xzmxGameCode" @change="changeXzmxGame">
                        <option :value="item.code" v-for="(item, index) in menuList" :key="index">{{ item.menu }}</option>
                      </select>
                    </label>&nbsp;&nbsp;
                    <label>
                      日期:
                      <select name="beforeDate" v-model="chooseDate">
                        <option :value="item.date" v-for="(item, index) in xzDate.slice(0, 7)" :key="index">{{ item.date
                          }}
                        </option>
                      </select>
                    </label>&nbsp;&nbsp;
                    <label>
                      期数:
                      <select v-model="chooseQihao">
                        <option :value="item" v-for="(item, index) in issuelist" :key="index">{{ item }}</option>
                      </select>
                    </label>&nbsp;&nbsp;
                    <label>
                      状态:
                      <select name="settlement" v-model="ztm">
                        <option :value="item.value" v-for="(item, index) in ztList" :key="index">{{ item.ztz }}</option>
                      </select>
                    </label>&nbsp;&nbsp;
                    <label>
                      订单号：
                      <input type="text" class="text-input sw90" name="no" v-model="orderNum" />&nbsp;&nbsp;
                      <a href="javascript:void(0);" name="search" @click="searchMx()">查詢</a>&nbsp;&nbsp;
                      <a href="javascript:void(0);" name="batchtuima" @click="batchCharge()">批量退码</a>
                    </label>
                  </div>
                </div>
                <div id="result2">
                  <div class="history_wrap">
                    <table>
                      <thead>
                        <tr>
                          <th width="15%">注单编号</th>
                          <th width="15%">下单时间</th>
                          <th width="7%">号码</th>
                          <th width="7%">赔率</th>
                          <th width="7%">金额</th>
                          <th width="7%">中奖</th>
                          <th width="7%">回水</th>
                          <th width="7%">盈亏</th>
                          <th width="7%">状态</th>
                          <th width="12%">
                            全选
                            <input id="quanxian" type="checkbox" @click="chooseCheckBox()" />
                            <input @click="zxChargeback()" id="tuima" type="button" value="退码" />
                          </th>
                        </tr>
                      </thead>
                      <tbody id="betList" v-if="!xzmxList[0]">
                        <tr>
                          <td colspan="10">暂无数据！</td>
                        </tr>
                        <tr>
                          <td colspan="3">合计</td>
                          <td>-</td>
                          <td>0.00</td>
                          <td>0.00</td>
                          <td>0.00</td>
                          <td>0.00</td>
                          <td colspan="2"></td>
                        </tr>
                      </tbody>
                      <tbody id="betList" v-else>
                        <tr v-for="(item, index) in xzmxList" :key="index"
                          :class="[item.orderStatus == 2 ? 'charge' : '']">
                          <td>{{ item.orderId }}</td>
                          <td>{{ item.betTime }} {{ item.chargebackTime != 0 ? '退' + item.chargebackTime : '' }}</td>
                          <td>{{ item.betNumber }}</td>
                          <td>{{ formatOrderPeilv(item, 2) }}</td>
                          <td>{{ (item.money * 1).toFixed(2) }}</td>
                          <td :style="(item.peie * 1) > 0 ? 'color : red' : ''">{{ item.orderStatus == 1 ? (item.peie *
                            1).toFixed(2) : '-' }}</td>
                          <td>{{ (item.back * 1).toFixed(2) }}</td>
                          <td>{{ getXzmxProfit(item) }}</td>
                          <td>{{ getXzmxStatusName(item) }}</td>
                          <td>
                            <span
                              v-if="item.orderStatus == 2 || item.issue != xzmxQH || (item.issue == xzmxQH && xzmxIsClose == 1)">--</span>
                            <input v-else v-model="item.checked" type="checkbox" :check="check" />
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3">合计</td>
                          <td>-</td>
                          <td>{{ (sum(validXzmxList(), 'money') * 1).toFixed(2) }}</td>
                          <td>{{ (sum(validXzmxList(), 'peie') * 1).toFixed(2) }}</td>
                          <td>{{ (sum(validXzmxList(), 'back') * 1).toFixed(2) }}</td>
                          <td>{{ getXzmxProfitTotal() }}</td>
                          <td colspan="2"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="game_tips_box">
                <div class="game_tips_bg"></div>
                <span class="tipsText"></span>
              </div>
            </div>

            <!-- gameBoxTool start -->
            <div id="gameBoxTool" class="game_box_tool base-clear" style="width: 1180px;text-align:center">
              <div id="shell_pageControl">
                <div class="pager" id="data-page">
                  <span @click="zxFirstPage()" class="first cursor" id="first">首页</span>
                  <span @click="zxPrevious()" class="previous cursor" id="previous">上一页</span>
                  <span class="current_page">
                    第
                    <b id="currentPage">{{ zxDetailNowPage }}</b>页
                  </span>
                  <span class="total_page">
                    共
                    <b class="total" id="totalPage">{{ zxDetailCount }}</b>页
                  </span>
                  <span @click="zxNext()" class="next cursor" id="next">下一页</span>
                  <span @click="zxLastPage()" class="last cursor" id="last">尾页</span>
                </div>
              </div>
            </div>
            <!-- gameBoxTool end -->
          </div>
        </div>
      </div>
    </div>

    <div class="gameLeft" v-if="qbb">
      <div class="game_wrap" style>
        <div class="game_box tab_box">
          <div class="game_box_title" id="game_box_title">
            <ul id="numNavList" class="base-clear">
              <li :class="isSubNavActive(item, index) ? 'subBtn active' : 'subBtn'" v-for="(item, index) in subNavList"
                :key="index">
                <a href="javascript:void(0)" @click="changeRoute(item.title)">{{ item.title }}</a>
              </li>
            </ul>
          </div>
          <div class="game_box_con">
            <div class="game_loading_wrap">
              <p>
                正在为您加载
                <span>请您稍后</span>
              </p>
              <p class="game_loding"></p>
            </div>

            <div class="game_item_warp">
              <div id="gameBox" class="game_item" style="display: block;">
                <div class="shell-top" id="shell-top">
                  <div id="title-nav" style="margin-top: 5px">
                    &nbsp;&nbsp;
                    <label>
                      彩种:
                      <select name="gameIndex" v-model="qbbGameCode" @change="requestIssueReport">
                        <option :value="item.code" v-for="(item, index) in menuList" :key="index">{{ item.menu }}</option>
                      </select>
                    </label>
                  </div>
                </div>
                <div id="result2">
                  <div class="history_wrap">
                    <table>
                      <thead>
                        <tr>
                          <th width="15%">期数</th>
                          <th width="10%">笔数</th>
                          <th width="7%">下注金额</th>
                          <th width="7%">有效金额</th>
                          <th width="10%">中奖</th>
                          <th width="10%">回水</th>
                          <th width="10%">盈亏</th>
                        </tr>
                      </thead>
                      <tbody id="betList">
                        <tr v-for="(item, index) in qbbList" :key="index">
                          <td @click="xzmxTz(item.qihao)">
                            <a href="javascript:void(0)" style="cursor: pointer" class="blue">{{ item.qihao }}</a>
                          </td>
                          <td>{{ item.issueNum }}</td>
                          <td>{{ (item.betMoney * 1).toFixed(2) }}</td>
                          <td>{{ item.ispei == 0 ? '-' : (item.vaildMoney * 1).toFixed(2) }}</td>
                          <td>{{ item.ispei == 0 ? '-' : (item.drawMoney * 1).toFixed(2) }}</td>
                          <td>{{ item.ispei == 0 ? '-' : (item.backMoney * 1).toFixed(2) }}</td>
                          <td :style="{ color: item.winorlose < 0 ? 'red' : 'green' }">{{ item.ispei == 0 ? '-' :
                            (item.winorlose * 1).toFixed(2) }}</td>
                        </tr>
                        <tr v-if="qbb.lenght != 0" style="font-weight: bolder;">
                          <td style="color: red">合计</td>
                          <td>{{ (sum(qbbList, 'issueNum') * 1).toFixed(2) }}</td>
                          <td>{{ (sum(qbbList, 'betMoney') * 1).toFixed(2) }}</td>
                          <td>{{ (sum(qbbList, 'vaildMoney') * 1).toFixed(2) }}</td>
                          <td>{{ (sum(qbbList, 'drawMoney') * 1).toFixed(2) }}</td>
                          <td>{{ (sum(qbbList, 'backMoney') * 1).toFixed(2) }}</td>
                          <td :style="{ color: sum(qbbList, 'winorlose') < 0 ? 'red' : 'green' }">{{ (sum(qbbList,
                            'winorlose') * 1).toFixed(2) }}</td>
                        </tr>
                        <tr v-if="qbb.lenght == 0">
                          <td colspan="10">暂无数据！</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="game_tips_box">
                <div class="game_tips_bg"></div>
                <span class="tipsText"></span>
              </div>
            </div>

            <!-- gameBoxTool start -->
            <div id="gameBoxTool" class="game_box_tool base-clear" style="display: none">
              <div id="shell_pageControl">
                <div class="pager" id="data-page">
                  <span class="first cursor" id="first">首页</span>
                  <span class="previous cursor" id="previous">上一页</span>
                  <span class="current_page">
                    第
                    <b id="currentPage">1</b>页
                  </span>
                  <span class="total_page">
                    共
                    <b class="total" id="totalPage">1</b>页
                  </span>
                  <span class="next cursor" id="next">下一页</span>
                  <span class="last cursor" id="last">尾页</span>
                </div>
              </div>
            </div>
            <!-- gameBoxTool end -->
          </div>
        </div>
      </div>
    </div>

    <div class="gameLeft" v-if="jsbb || bbDetails || issueDetail">
      <div class="game_wrap" style="width: auto">
        <div class="game_box tab_box">
          <div class="game_box_title" id="game_box_title">
            <ul id="numNavList" class="base-clear">
              <li :class="isSubNavActive(item, index) ? 'subBtn active' : 'subBtn'" v-for="(item, index) in subNavList"
                :key="index">
                <a href="javascript:void(0)" @click="changeRoute(item.title)">{{ item.title }}</a>
              </li>
            </ul>
          </div>
          <div class="game_box_con">
            <div class="game_item_warp settlement_report_wrap">
              <div id="gameBox" class="game_item" style="display: block;">
                <div id="result" v-if="jsbb">
                  <div class="shell-top" id="shell-top">
                    <div class="" id="title-nav" style="margin-top: 5px;">
                      &nbsp;&nbsp;
                      <label>
                        周报表
                        |
                        <a href="javascript:void(0)" :style="{ color: reportRangeType == 'lastWeek' ? '#193dce' : '' }" @click="setSettlementRange('lastWeek')">上周</a>
                        |
                        <a href="javascript:void(0)" :style="{ color: reportRangeType == 'thisWeek' ? '#193dce' : '' }" @click="setSettlementRange('thisWeek')">本周</a>
                        |
                        <a href="javascript:void(0)" :style="{ color: reportRangeType == 'lastHalfMonth' ? '#193dce' : '' }" @click="setSettlementRange('lastHalfMonth')">上半月</a>
                        |
                        <a href="javascript:void(0)" :style="{ color: reportRangeType == 'thisHalfMonth' ? '#193dce' : '' }" @click="setSettlementRange('thisHalfMonth')">本半月</a>
                        |
                        <input class="text-input sw90" type="text" v-model="reportStartDate" />
                        ~
                        <input class="text-input sw90" type="text" v-model="reportEndDate" />
                        |
                        <select name="reportGameCode" v-model="reportGameCode">
                          <option value="">全部游戏</option>
                          <option :value="item.code || item.gameCode || item.game_code" v-for="(item, index) in reportGameList" :key="index">
                            {{ item.gameName || item.menu || item.name || item.code || item.gameCode || item.game_code }}
                          </option>
                        </select>
                        <input class="btn hotBtn" type="button" value="查询" @click="requestSettlementReport()" />
                      </label>
                    </div>
                  </div>
                  <div class="history_wrap">
                    <table class="settlement-report-table">
                      <thead>
                        <tr>
                          <th class="date-col">日期</th>
                          <th class="amount-col">笔数</th>
                          <th class="amount-col">金额</th>
                          <th class="amount-col">回水</th>
                          <th class="amount-col">中奖</th>
                          <th class="amount-col">盈亏</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="cursor"
                          v-for="(item,index) in dataList"
                          :key="index"
                          @click="reportDetail(item)"
                        >
                          <td class="date-col">
                            <a href="javascript:void(0)">[ {{index + 1}} ] ({{getSettlementReportDisplayDate(item)}})</a>
                          </td>
                          <td class="amount-col">{{formatReportNumber(getSettlementReportValue(item, 'count'), false)}}</td>
                          <td class="amount-col">{{formatReportNumber(getSettlementReportValue(item, 'money'))}}</td>
                          <td class="amount-col">{{formatReportNumber(getSettlementReportValue(item, 'back'))}}</td>
                          <td class="amount-col">{{formatReportNumber(getSettlementReportValue(item, 'draw'))}}</td>
                          <td class="amount-col">{{formatReportNumber(getSettlementReportValue(item, 'profit'))}}</td>
                        </tr>
                        <tr class="settlement-total-row">
                          <td class="date-col">合计</td>
                          <td class="amount-col">{{formatReportNumber(getSettlementReportTotal('count'), false)}}</td>
                          <td class="amount-col">{{formatReportNumber(getSettlementReportTotal('money'))}}</td>
                          <td class="amount-col">{{formatReportNumber(getSettlementReportTotal('back'))}}</td>
                          <td class="amount-col">{{formatReportNumber(getSettlementReportTotal('draw'))}}</td>
                          <td class="amount-col">{{formatReportNumber(getSettlementReportTotal('profit'))}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div id="result" v-if="bbDetails">
                  <div class="MenuBox1">
                    <label class="cursor" @click="backToReport()">&lt;&lt;返回</label>
                  </div>
                  <div class="history_wrap MenuPadding-top">
                    <table>
                      <thead>
                        <tr>
                          <th>彩种类型</th>
                          <th>注单笔数</th>
                          <th>下注总额</th>
                          <th>有效总额</th>
                          <th>结果</th>
                          <th>退水</th>
                          <th>实际结果</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr @click="toIssueDetail(item)" class="cursor" mystate="3" v-for="(item, index) in openReportDetailList" :key="index">
                          <td>{{item.gameName}}</td>
                          <td>{{item.num}}</td>
                          <td style="text-align:right;padding-right:5px;">{{(item.betMoney * 1).toFixed(2)}}</td>
                          <td style="text-align:right;padding-right:5px;">{{(item.vaildMoney * 1).toFixed(2)}}</td>
                          <td style="text-align:right;padding-right:5px;color:red;">{{(item.afterBackMoney * 1).toFixed(2)}}</td>
                          <td style="text-align:right;padding-right:5px;color:red;">{{formatReportNumber(getDayReportBackValue(item))}}</td>
                          <td style="text-align:right;padding-right:5px;color:red;">{{(item.actualMoney * 1).toFixed(2)}}</td>
                        </tr>
                        <tr v-if="openReportDetailList.length == 0">
                          <td colspan="7">无未结算记录！</td>
                        </tr>
                        <tr class="bc bold">
                          <td>当前页合计</td>
                          <td>{{reportSum(openReportDetailList, 'num')}}</td>
                          <td style="text-align:right;padding-right:5px;">{{(reportSum(openReportDetailList, 'betMoney') * 1).toFixed(2)}}</td>
                          <td style="text-align:right;padding-right:5px;">{{(reportSum(openReportDetailList, 'vaildMoney') * 1).toFixed(2)}}</td>
                          <td style="text-align:right;padding-right:5px;">{{(reportSum(openReportDetailList, 'afterBackMoney') * 1).toFixed(2)}}</td>
                          <td style="text-align:right;padding-right:5px;">{{formatReportNumber(getDayReportBackTotal(openReportDetailList))}}</td>
                          <td style="text-align:right;padding-right:5px;color:red;">{{(reportSum(openReportDetailList, 'actualMoney') * 1).toFixed(2)}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div id="result" v-if="issueDetail">
                  <div class="MenuBox1">
                    <label class="cursor" @click="backToReport()">&lt;&lt;返回</label>
                  </div>
                  <div class="history_wrap MenuPadding-top">
                    <table>
                      <thead>
                        <tr>
                          <th>期数</th>
                          <th>笔数</th>
                          <th>下注金额</th>
                          <th>有效金额</th>
                          <th>中奖</th>
                          <th>回水</th>
                          <th>盈亏</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in issueDetailList.slice(0, showIssueDetailCount)" :key="index">
                          <td>{{item.qihao}}</td>
                          <td>{{item.issueNum}}</td>
                          <td style="text-align:right;padding-right:5px;">{{(item.betMoney * 1).toFixed(2)}}</td>
                          <td style="text-align:right;padding-right:5px;">{{(item.vaildMoney * 1).toFixed(2)}}</td>
                          <td style="text-align:right;padding-right:5px;">{{(item.drawMoney * 1).toFixed(2)}}</td>
                          <td style="text-align:right;padding-right:5px;">{{(item.backMoney * 1).toFixed(2)}}</td>
                          <td style="text-align:right;padding-right:5px;color:red;">{{(item.winorlose * 1).toFixed(2)}}</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <th>当前页合计：<span name="data-count">{{issueDetailList.length}}</span>期</th>
                          <th style="text-align:right;padding-right:5px;"><span name="data-a">{{reportSum(issueDetailList.slice(0, showIssueDetailCount), 'issueNum')}}</span></th>
                          <th style="text-align:right;padding-right:5px;"><span name="data-b">{{(reportSum(issueDetailList.slice(0, showIssueDetailCount), 'betMoney') * 1).toFixed(2)}}</span></th>
                          <th style="text-align:right;padding-right:5px;"><span name="data-c">{{(reportSum(issueDetailList.slice(0, showIssueDetailCount), 'vaildMoney') * 1).toFixed(2)}}</span></th>
                          <th style="text-align:right;padding-right:5px;"><span name="data-d">{{(reportSum(issueDetailList.slice(0, showIssueDetailCount), 'drawMoney') * 1).toFixed(2)}}</span></th>
                          <th style="text-align:right;padding-right:5px;"><span name="data-e">{{(reportSum(issueDetailList.slice(0, showIssueDetailCount), 'backMoney') * 1).toFixed(2)}}</span></th>
                          <th style="text-align:right;padding-right:5px;color: red"><span name="data-f">{{(reportSum(issueDetailList.slice(0, showIssueDetailCount), 'winorlose') * 1).toFixed(2)}}</span></th>
                        </tr>
                      </tfoot>
                    </table>
                    <div id="fondiv" style="text-align:center;padding:1px 0;margin-top:2px;">
                      <a v-if="showIssueDetailCount <= issueDetailList.length -1" href="javascript:void(0);" @click="showMoreIssueDetail()">点击获取更多...</a>
                      <span v-else id="nodataTitle" class="">无数據加載！</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="game_tips_box">
                <div class="game_tips_bg"></div>
                <span class="tipsText"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="gameLeft" v-if="kxrz">
      <div class="game_wrap" style>
        <div class="game_box tab_box">
          <div class="game_box_title" id="game_box_title">
            <ul id="numNavList" class="base-clear">
              <li :class="isSubNavActive(item, index) ? 'subBtn active' : 'subBtn'" v-for="(item, index) in subNavList"
                :key="index">
                <a href="javascript:void(0)" @click="changeRoute(item.title)">{{ item.title }}</a>
              </li>
            </ul>
          </div>
          <div style="display:block; height: 25px;margin-top: 5px;">
            <ul class="thirdBtn_title">
              <li @click="thirdBtnLog('actionLog')" class="thirdBtn" :class="[actionLog ? 'active' : '']"><a
                  style="cursor:pointer">操作日志</a></li>
              <li @click="thirdBtnLog('betLog')" class="thirdBtn" :class="[betLog ? 'active' : '']"><a
                  style="cursor:pointer">投注日志</a></li>
            </ul>
          </div>
          <div class="game_box_con" style="padding-top: 0">
            <div class="game_loading_wrap">
              <p>
                正在为您加载
                <span>请您稍后</span>
              </p>
              <p class="game_loding"></p>
            </div>

            <div class="game_item_warp" style="">
              <div id="gameBox" class="game_item" style="display: block;">
                <div class="shell-top" id="shell-top">
                  <div id="title-nav" style="margin-top: 5px">
                    &nbsp;&nbsp;
                    <label v-if="kxrz && betLog && !actionLog">
                      彩种:
                      <select name="gameIndex" v-model="betLogGameCode" @change="searchLog">
                        <option value="">全部</option>
                        <option :value="item.code" v-for="(item, index) in menuList" :key="index">{{ item.menu }}</option>
                      </select>
                      &nbsp;&nbsp;
                    </label>
                    <label v-if="kxrz && betLog && !actionLog">
                      类型:
                      <select name="type" v-model="betLog_type">
                        <option value="">全部</option>
                        <option value="D1W">一定</option>
                        <option value="D2W">二定</option>
                        <option value="D3W">三定</option>
                        <option value="D4W">四定</option>
                        <option value="LM">两面</option>
                        <option value="FT">番摊</option>
                        <option value="daoru">txt导入</option>
                        <option value="kuaida">快打</option>
                      </select>
                      &nbsp;&nbsp;
                    </label>
                    <label v-if="kxrz && !betLog && actionLog">
                      类型:
                      <select name="type" v-model="actionLog_type">
                        <option value="odds">修改赔率</option>
                        <option value="changepwd">修改密码</option>
                        <option value="login">登录日志</option>
                      </select>
                      &nbsp;&nbsp;
                    </label>
                    <label v-if="kxrz && betLog && !actionLog">
                      路径:
                      <select name="type" v-model="betLog_playType">
                        <option value="">全部</option>
                        <option value="zhixuan">直选</option>
                        <option value="kuaida">快打</option>
                        <option value="kuaixuan">快选</option>
                        <option value="robot">机打</option>
                      </select>
                      &nbsp;&nbsp;
                    </label>
                    <label>
                      日期:
                      <select name="beforeDate" v-model="log_chooseDate">
                        <option :value="item.date" v-for="(item, index) in xzDate.slice(0, 7)" :key="index">{{ item.date
                          }}
                        </option>
                      </select>
                      &nbsp;&nbsp;
                    </label>
                    <label v-if="kxrz && betLog && !actionLog">
                      订单号:
                      &nbsp;
                      <input type="text" class="text-input sw90" name="no" v-model="betLog_orderNum" />&nbsp;&nbsp;
                    </label>
                    <a href="javascript:void(0);" name="search" @click="searchLog()">查詢</a>&nbsp;&nbsp;
                  </div>
                </div>
                <div v-if="kxrz && betLog && !actionLog" id="result2">
                  <div class="history_wrap">
                    <table>
                      <thead>
                        <tr>
                          <th>用户</th>
                          <th>投注时间</th>
                          <th>订单号</th>
                          <th>期号</th>
                          <th>彩种</th>
                          <th>投注类型</th>
                          <th>玩法路径</th>
                          <th>IP</th>
                          <th>归属地</th>
                          <th>操作</th>
                        </tr>
                      </thead>
                      <tbody id="kxLogs" v-if="kxrzList[0]">
                        <tr v-for="(item, index) in kxrzList" :key="index">
                          <td>{{ item.username }}</td>
                          <td>{{ item.timeStamp }}</td>
                          <td>{{ item.orderId }}</td>
                          <td>{{ item.issue }}</td>
                          <td>{{ getBetLogGameName(item) }}</td>
                          <td>{{ getBetLogPlayCodeName(item.playCode) }}</td>
                          <td>{{ item.playType == "zhixuan" ? "直选" : item.playType == "kuaixuan" ? "快选" : item.playType
                            == "kuaida" ? "快打" : item.playType == "daoru" ? "导入" : item.playType == "robot" ? "机打" :
                              "-" }}</td>
                          <td>{{ item.ip }}</td>
                          <td>{{ item.area }}</td>
                          <td><a style="color: blue; cursor: pointer;" @click="betLogDetail(item)">详情</a></td>
                        </tr>
                      </tbody>
                      <tbody id="kxLogs" v-else>
                        <tr>
                          <td colspan="10">暂无数据！</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div v-if="kxrz && actionLog && !betLog" id="result2">
                  <div class="history_wrap">
                    <table>
                      <thead>
                        <tr>
                          <th>用户</th>
                          <th>操作时间</th>
                          <th>操作类型</th>
                          <th>IP</th>
                          <th>归属地</th>
                          <th>操作</th>
                        </tr>
                      </thead>
                      <tbody id="kxLogs" v-if="kxrzList[0]">
                        <tr v-for="(item, index) in kxrzList" :key="index">
                          <td>{{ item.username }}</td>
                          <td>{{ item.timeStamp }}</td>
                          <td>{{ item.type == "login" ? "登录" : item.type == "changepwd" ? "修改密码" : item.type == "odds" ?
                            "修改赔率" : "-" }}</td>
                          <td>{{ item.ip }}</td>
                          <td>{{ item.area }}</td>
                          <td>
                            <a style="color: blue; cursor: pointer;" v-if="item.type == 'odds'"
                              @click="actionLogDetail(item)">详情</a>
                            <span v-else>-</span>
                          </td>
                        </tr>
                      </tbody>
                      <tbody id="kxLogs" v-else>
                        <tr>
                          <td colspan="10">暂无数据！</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="game_tips_box">
                <div class="game_tips_bg"></div>
                <span class="tipsText"></span>
              </div>
            </div>

            <!-- gameBoxTool start -->
            <div id="gameBoxTool" class="game_box_tool base-clear" style="width: 850px;text-align:center">
              <div id="shell_pageControl">
                <div class="pager" id="data-page">
                  <span class="first cursor" id="first" @click="logFirstPage()">首页</span>
                  <span class="previous cursor" id="previous" @click="logPrevious()">上一页</span>
                  <span class="current_page">
                    第
                    <b id="currentPage">{{ logNowPage }}</b>页
                  </span>
                  <span class="total_page">
                    共
                    <b class="total" id="totalPage">{{ logCount }}</b>页
                  </span>
                  <span class="next cursor" id="next" @click="logNext()">下一页</span>
                  <span class="last cursor" id="last" @click="logLastPage()">尾页</span>
                </div>
              </div>
            </div>
            <!-- gameBoxTool end -->
          </div>
        </div>
      </div>

      <div id="hot_Cool" class="hot_Cool"></div>

      <!-- trend start -->
      <div id="cqlResult" class="trend_wrap tab_box"></div>
      <!-- trend end -->
    </div>
  </div>
</template>

<script>
import {
  createNum,
  changeXz,
  yzdMethod,
  gameSubmit,
  DataTime,
  kxcontent,
  changeSubNavInfo,
  kdjstj,
  kd
} from "../../assets/js/base";
import { bindGameFun, G, container } from "../../assets/js/gamedefault";
import { txtdaoru, uploadfile } from "../../assets/js/gamemiddle";
import getData from "../getData/getData";
import axios from 'axios';
export default {
  name: "",
  data() {
    return {
      betLog_detail: null,
      showIssueDetailCount: 5,
      issueDetailList: [],
      openReportDetail: {},
      openReportDetailList: [],
      reportBetDate: "",
      reportStartDate: "",
      reportEndDate: "",
      reportRangeType: "thisWeek",
      reportGameCode: "",
      dataList: [],
      reportGameList: [],
      jsbb: false,
      bbDetails: false,
      issueDetail: false,
      betLog_orderNum: "",
      log_chooseDate: '',
      betLog: false,
      actionLog: false,
      actionLog_type: '',
      betLog_playType: '',
      betLog_type: "",
      betLogGameCode: "",
      xzmxGameCode: "",
      zxDetailNowPage: 1,
      zxDetailLmit: 30,
      zxDetailCount: 0,
      logNowPage: 1,
      logLmit: 20,
      logCount: 0,
      yzdMoney: "",
      ezdMoney: "",
      kdQX: false,
      issuelist: [],
      xzmxList: [],
      xzmxQH: "",      //记录当前期号
      xzmxIsClose: true,  //记录当前期号是否封盘
      ztm: -1,
      ztList: [
        { value: -1, ztz: "全部" },
        // { value: 0, ztz: "未赔" },
        { value: 0, ztz: "成功" },
        // { value: 2, ztz: "退码" },
        // { value: 3, ztz: "停码" },
        { value: 6, ztz: "未中" },
        { value: 5, ztz: "中奖" },
        { value: 2, ztz: "退码" },
        { value: 4, ztz: "撤回" },
        { value: 7, ztz: "回本" },
      ],
      indexTab: 0,
      tabIndex: 2,
      ballListLM: [],
      ballListFT: [],
      ballListD1W: [],
      ballListD2W: [],
      selectedIndex: 0,
      ezdChangeSubNavList: [],
      ezdSubNavList: [
      ],
      orderNum: "",
      zxdetails: false,
      createTj: false,
      lm: false,
      ft: false,
      yzd: true,
      ezd: false,
      kd: false,
      kx: false,
      txtdr: false,
      qbb: false,
      kxrz: false,
      hewfx: false,
      qbbToZxdetail: false,   //期报表跳转到注选明细的标识
      qbbGameCode: "",
      qbbList: [],
      kxrzList: [],
      kdList: [],
      currentGameName: window.sessionStorage.getItem("gameName") || "",
      ftRows: [
        ["三门234", "一通23", "一通24", "一通34", "12角", "1念2", "1念3", "1念4", "14角"],
        {
          left: ["三门134", "二通13", "二通14", "二通34", "2念1"],
          right: "4念1"
        },
        {
          left: ["三门124", "三通12", "三通14", "三通24", "2念3"],
          right: "4念2"
        },
        {
          left: ["三门123", "四通12", "四通13", "四通23", "2念4"],
          right: "4念3"
        },
        ["1正", "2正", "3正", "4正", "23角", "3念1", "3念2", "3念4", "34角"]
      ],
      allSubNavList: [
        { title: "两面" },
        { title: "番摊" },
        { title: "一字定" },
        { title: "二字定" },
        { title: "快打" },
        { title: "快选" },
        { title: "txt导入" }
      ],
      subNavList: [
        { title: "两面" },
        { title: "番摊" },
        { title: "一字定" },
        { title: "二字定" },
        { title: "快打" },
        { title: "快选" },
        { title: "txt导入" }
      ],
      subZdList: [
        {
          title: "二字定"
        },
        {
          title: "三字定"
        },
        {
          title: "四字定"
        }
      ],
      menuList: [],
      chooseDate: "",
      xzDate: [],
      chooseQihao: "",
      qiHaoList: [],
      check: false,
      tempTitle: "一字定",
      // qbbDetailQh: "",
    };
  },
  computed: {
    ftOddsMap() {
      const map = {};
      this.ballListFT.forEach((item, index) => {
        const number = item && typeof item.number === "string" ? item.number : "";
        if (!number) {
          return;
        }
        map[this.formatFTName(number)] = {
          ...item,
          __sort: index + 1
        };
      });
      return map;
    },
    lmOddsGroups() {
      const groupMap = {};
      const order = [];
      const ballTitleMap = {
        1: "第一球",
        2: "第二球",
        3: "第三球",
        4: "第四球",
        5: "第五球"
      };
      const pushItem = (title, item, name, sort) => {
        if (!groupMap[title]) {
          groupMap[title] = [];
          order.push(title);
        }
        groupMap[title].push({
          ...item,
          __name: name,
          __sort: sort
        });
      };

      this.ballListLM.forEach((item, index) => {
        const number = item && typeof item.number === "string" ? item.number : "";
        if (!number) {
          return;
        }
        const ballMatch = number.match(/^(\d)球(.+)$/);
        if (ballMatch) {
          pushItem(ballTitleMap[ballMatch[1]] || `${ballMatch[1]}球`, item, ballMatch[2], index + 1);
          return;
        }
        if (number.indexOf("总和") === 0) {
          pushItem("总和", item, number.replace("总和", ""), index + 1);
          return;
        }
        pushItem("龙虎和", item, number, index + 1);
      });

      return order.map(title => ({
        title,
        items: groupMap[title]
      }));
    },
    d1wBallGroups() {
      const groups = [[], [], [], [], []];
      this.ballListD1W.forEach(item => {
        const number = item && typeof item.number === "string" ? item.number : "";
        const match = number.match(/\d/);
        if (!match) {
          return;
        }
        const digit = Number(match[0]);
        const position = number.indexOf(match[0]);
        if (position < 0 || position > 4) {
          return;
        }
        groups[position].push({
          ...item,
          __digit: digit
        });
      });
      return groups.map(group => group
        .sort((a, b) => a.__digit - b.__digit)
        .map(({ __digit, ...item }) => item));
    },
    ezdColumnGroups() {
      const groups = [];
      for (let i = 0; i < 10; i++) {
        const items = this.ezdChangeSubNavList.slice(i * 10, i * 10 + 10);
        if (items.length > 0) {
          groups.push({
            startSort: items[0].__sort,
            items
          });
        }
      }
      return groups;
    }
  },
  mounted() {
    let _this = this
    this.applyGameNav(this.getStoredGameNav());
    setTimeout(() => {
      DataTime();
      $(".game_loading_wrap").css({
        display: "none"
      });
      $(".game_item_warp").css({
        display: "inline-block"
      });

      let dataObj = {};
      dataObj.access_token = window.sessionStorage
        .getItem("login")
        .split("&")[0];
      dataObj.uid = window.sessionStorage.getItem("login").split("&")[1];
      dataObj.code = window.sessionStorage.getItem("code");
      dataObj.playcode = "D1W";
      getData.postAxiosMethod("odds/odds", dataObj, res => {
        if (window.sessionStorage.getItem("isClose") == "0") {
          this.ballListD1W = res.data.data;
        } else {
          res.data.data.forEach((item, index) => {
            res.data.data[index].peilv = "-";
          });
          this.ballListD1W = res.data.data;
        }
      });
      setTimeout(() => {
        bindGameFun(_this);
      }, 1000)
    }, 300);
    this.chooseDate = this.getBeforeDate(0);
    for (let i = 0; i < 14; i++) {
      let obj = {};
      obj.date = this.getBeforeDate(i);
      this.xzDate.push(obj);
    }

    for (let i = 288; i > 0; i--) {
      let obj = {};
      if (i < 100 && i > 9) {
        obj.qihao = this.getQihao(0) + "0" + i.toString();
      } else if (i < 10 && i > -1) {
        obj.qihao = this.getQihao(0) + "00" + i.toString();
      } else {
        obj.qihao = this.getQihao(0) + i.toString();
      }
      this.qiHaoList.push(obj);
    }
    let obj = {};
    obj.qihao = "全部";
    this.qiHaoList.unshift(obj);
    // this.chooseQihao = "全部";

    this.$event.$on('updateIssueList', () => {
      // let date = this.getBeforeDate(0);
      // setTimeout(() => {
      //   this.getIssuelist(date, 'update')
      // }, 300)
      // this.changeContainer('下注明细')
      this.xzDate = [];
      for (let i = 0; i < 14; i++) {
        let obj = {};
        obj.date = this.getBeforeDate(i);
        this.xzDate.push(obj);
      }
    })

    this.$event.$on('yzdData', (type) => {
      this.$emit('yzdData', type)
    })
    this.$event.$on('updateOdds', () => {
      setTimeout(() => {
        this.updateOdds()
      }, 5000);
    })
    this.$event.$on('updateGameNav', (nav) => {
      this.applyGameNav(nav, true);
    })
    this.$event.$on('updateQH', () => {
      this.xzmxQH = sessionStorage.getItem("qiNum")
      this.xzmxIsClose = sessionStorage.getItem("isClose")
      this.xzmxList = JSON.parse(JSON.stringify(this.xzmxList))
    })

  },
  filters: {
    gameCodeFormate(value) {
      let returnStr = '';
      switch (value) {
        case 'hn5fc':
          returnStr = window.sessionStorage.getItem("gameName") || value
          break;
      }
      return returnStr
    }
  },
  watch: {
    // zxDetailNowPage: 1,
    //   zxDetaiLmit: 30,
    //   zxDetaiCount: 0,
    zxdetails() {
      this.check = false
      this.xzmxQH = sessionStorage.getItem("qiNum")
      this.xzmxIsClose = sessionStorage.getItem("isClose")
      this.xzmxList = JSON.parse(JSON.stringify(this.xzmxList))
    },
    actionLog_type() {
      this.searchLog()
    },
    log_chooseDate() {
      this.searchLog()
    },
    betLog_type() {
      this.searchLog()
    },
    betLog_playType() {
      this.searchLog()
    },
    logNowPage() {
      let data = {};
      data.access_token = window.sessionStorage
        .getItem("login")
        .split("&")[0];
      data.uid = window.sessionStorage.getItem("login").split("&")[1];
      data.beforeDate = this.log_chooseDate
      data.page = this.logNowPage
      data.limit = this.logLmit
      if (this.betLog) {
        if (this.betLogGameCode) {
          data.game_code = this.betLogGameCode
        }
        data.play_code = this.betLog_type
        data.play_type = this.betLog_playType
        data.orderId = this.betLog_orderNum
        getData.postAxiosMethod("betlog", data, res => {
          let date = new Date(),
            dt;
          res.data.data.forEach(item => {
            dt = date.setTime(item.timeStamp * 1000);
            item.timeStamp = date.Format("MM-dd HH:mm", dt);
          });
          this.kxrzList = res.data.data;
          this.logCount = Math.ceil(res.data.count / this.logLmit) || 0
        });
      } else if (this.actionLog) {
        data.type = this.actionLog_type
        getData.postAxiosMethod("actionlog", data, res => {
          let date = new Date(),
            dt;
          res.data.data.forEach(item => {
            dt = date.setTime(item.timeStamp * 1000);
            item.timeStamp = date.Format("MM-dd HH:mm", dt);
          });
          this.kxrzList = res.data.data;
          this.logCount = Math.ceil(res.data.count / this.logLmit) || 0
        });
      }
    },
    zxDetailNowPage() {
      this.searchMx()
    },
    yzdMoney(newVal) {
      console.log(newVal)
      $(".input.onlyNum.orderInput.check").val(newVal)
    },
    ezdMoney(newVal) {
      $(".input.onlyNum.orderInput.check").val(newVal)
    },
    kdQX(newVal) {
      this.kdList.slice(0, 10).forEach(item => {
        item.checked = newVal
      })
    },
    chooseDate(newVal) {
      let year = newVal.split("-")[0];
      let month =
        (newVal.split("-")[1] * 1) > 9
          ? newVal.split("-")[1]
          : "0" + newVal.split("-")[1];
      let day =
        (newVal.split("-")[2] * 1) > 9
          ? newVal.split("-")[2]
          : "0" + newVal.split("-")[2];
      let date = year + month + day;
      if (this.qbbToZxdetail) {
        this.qbbToZxdetail = false
      } else {
        this.getIssuelist(date)
      }
    },
    chooseQihao() {
      this.searchMx()
    },
    ztm() {
      this.searchMx()
    }
  },
  methods: {
    normalizeGameNav(nav) {
      if (Array.isArray(nav)) {
        return nav.map(item => (item || "").toString().trim()).filter(Boolean);
      }
      if (typeof nav == "string" && nav.trim() != "") {
        return nav.split(",").map(item => item.trim()).filter(Boolean);
      }
      return null;
    },
    getStoredGameNav() {
      const gameNav = window.sessionStorage.getItem("gameNav");
      if (!gameNav) {
        return null;
      }
      try {
        return JSON.parse(gameNav);
      } catch (e) {
        return gameNav;
      }
    },
    applyGameNav(nav, reloadActive) {
      this.currentGameName = window.sessionStorage.getItem("gameName") || this.currentGameName;
      const navList = this.normalizeGameNav(nav);
      if (navList) {
        this.subNavList = this.allSubNavList.filter(item => navList.indexOf(item.title) > -1);
      } else {
        this.subNavList = this.allSubNavList.slice();
      }

      const activeTitle = this.tempTitle || (this.allSubNavList[this.tabIndex] && this.allSubNavList[this.tabIndex].title);
      const hasActive = this.subNavList.some(item => item.title == activeTitle);
      if (hasActive) {
        this.tabIndex = this.getSubNavIndex(activeTitle);
        if (reloadActive) {
          this.changeRoute(activeTitle);
        }
        return;
      }

      const firstNav = this.subNavList[0] && this.subNavList[0].title;
      if (firstNav) {
        this.changeRoute(firstNav);
      } else {
        this.closeWin();
        this.tempTitle = "";
        this.tabIndex = -1;
      }
    },
    getSubNavIndex(title) {
      return this.subNavList.findIndex(item => item.title == title);
    },
    isSubNavActive(item, index) {
      if (this.tempTitle) {
        return item.title == this.tempTitle;
      }
      return index == this.tabIndex;
    },
    isSubNavVisible(title) {
      return this.subNavList.some(item => item.title == title);
    },
    removeTabIndex() {
      this.tabIndex = -1
      this.tempTitle = ""
    },
    getBetLogPlayCodeName(playCode) {
      const map = {
        D1W: "一字定",
        D2W: "二字定",
        D3W: "三字定",
        D4W: "四字定",
        LM: "两面",
        FT: "番摊",
        daoru: "txt导入"
      };
      return map[playCode] || "-";
    },
    getBetLogGameCode(item) {
      if (!item || typeof item !== "object") {
        return "";
      }
      return item.game_code || item.gameCode || item.code || "";
    },
    getBetLogGameName(item) {
      const gameCode = this.getBetLogGameCode(item);
      const gameInfo = this.menuList.find(game => {
        return (game.code || game.gameCode || game.game_code || "") == gameCode;
      });
      if (gameInfo) {
        return gameInfo.menu || gameInfo.gameName || gameInfo.name || gameCode;
      }
      return item.gameName || gameCode || "-";
    },
    actionLogDetail(log) {
      this.$event.$emit("actionLogDetail", log)
    },
    isFourDecimalPeilvPlay(playCode) {
      return playCode == "LM" || playCode == "FT";
    },
    getPeilvDefaultPrecision(playCode, fallbackPrecision) {
      if (this.isFourDecimalPeilvPlay(playCode) || playCode == "D1W") {
        return 2;
      }
      return fallbackPrecision == null ? 1 : fallbackPrecision;
    },
    formatPeilv(peilv, defaultPrecision = 2, maxPrecision = 4) {
      const number = peilv * 1;
      if (isNaN(number)) {
        return "-";
      }
      const str = peilv == null ? "" : peilv.toString();
      return str
        .replace(/(\.\d*?[1-9])0+$/, "$1")
        .replace(/\.0+$/, "");
    },
    formatOrderPeilv(item, fallbackPrecision) {
      const defaultPrecision = this.getPeilvDefaultPrecision(item && item.playCode, fallbackPrecision);
      return this.formatPeilv(item && item.peilv, defaultPrecision);
    },
    formatFTName(number) {
      const tongMatch = number.match(/^(\d{2})([一二三四]通)$/);
      if (tongMatch) {
        return tongMatch[2] + tongMatch[1];
      }
      const sanMenMatch = number.match(/^三门(\d)(\d)(\d)$/);
      if (sanMenMatch) {
        return "三门" + sanMenMatch.slice(1).sort().join("");
      }
      const zhengMatch = number.match(/^正(\d)$/);
      if (zhengMatch) {
        return zhengMatch[1] + "正";
      }
      const jiaoMatch = number.match(/^角(\d)(\d)$/);
      if (jiaoMatch) {
        return jiaoMatch.slice(1).sort().join("") + "角";
      }
      return number;
    },
    ftCell(label) {
      return this.ftOddsMap[label] || {
        number: label,
        peilv: "-",
        __sort: ""
      };
    },
    ftCellClass(label) {
      return {
        ft_cell: true,
        men: label.indexOf("三门") === 0,
        tong: label.indexOf("通") > -1,
        jiao: label.indexOf("角") > -1,
        zheng: label.indexOf("正") > -1,
        nian: label.indexOf("念") > -1,
        fan: /^\d番$/.test(label),
        dxds: /^番[大小单双]$/.test(label)
      };
    },
    getFTOdds() {
      let dataObj = {};
      dataObj.code = window.sessionStorage.getItem("code");
      dataObj.playcode = "FT";
      getData.postAxiosMethod("odds/odds", dataObj, res => {
        let list = res.data.data || [];
        if (window.sessionStorage.getItem("isClose") == "0") {
          this.ballListFT = list;
          setTimeout(() => {
            $(".ft_box_con #gameBox").find('input').attr('disabled', null)
          }, 500)
        } else {
          list.forEach((item, index) => {
            list[index].peilv = "-";
            setTimeout(() => {
              $(".ft_box_con #gameBox").find('input').attr('disabled', 'disabled')
            }, 500)
          });
          this.ballListFT = list;
        }
        $(".game_loading_wrap").css({
          display: "none"
        });
        $(".game_item_warp").css({
          display: "inline-block"
        });
        this.$nextTick(function () {
          bindGameFun(this);
          this.$emit("yzdData", 1);
        })
      });
    },
    getLMOdds() {
      let dataObj = {};
      dataObj.code = window.sessionStorage.getItem("code");
      dataObj.playcode = "LM";
      getData.postAxiosMethod("odds/odds", dataObj, res => {
        let list = res.data.data || [];
        if (window.sessionStorage.getItem("isClose") == "0") {
          this.ballListLM = list;
          setTimeout(() => {
            $(".game_box_zhixuan").find('input').attr('disabled', null)
          }, 500)
        } else {
          list.forEach((item, index) => {
            list[index].peilv = "-";
            setTimeout(() => {
              $(".game_box_zhixuan").find('input').attr('disabled', 'disabled')
            }, 500)
          });
          this.ballListLM = list;
        }
        $(".game_loading_wrap").css({
          display: "none"
        });
        $(".game_item_warp").css({
          display: "inline-block"
        });
        this.$nextTick(function () {
          bindGameFun(this);
          this.$emit("yzdData", 1);
        })
      });
    },
    selectAllBalls(type) {
      const selector = type == "ft" ? ".ft_box_con #gameBox" : ".game_box_con #gameBox";
      const money = $("#tool_ys_input").val();
      $(selector).find("input.orderInput:not(:disabled)").each(function () {
        $(this).val(money).addClass("check");
      });
    },
    betLogDetail(log) {
      this.$event.$emit("betLogDetail", log)
    },
    searchLog() {
      this.logNowPage = 1
      let data = {};
      data.access_token = window.sessionStorage
        .getItem("login")
        .split("&")[0];
      data.uid = window.sessionStorage.getItem("login").split("&")[1];
      data.play_code = this.betLog_type
      data.play_type = this.betLog_playType
      data.beforeDate = this.log_chooseDate
      data.orderId = this.betLog_orderNum
      data.page = this.logNowPage
      data.limit = this.logLmit
      this.$loading_show()
      if (this.betLog) {
        if (this.betLogGameCode) {
          data.game_code = this.betLogGameCode
        }
        getData.postAxiosMethod("betlog", data, res => {
          let date = new Date(),
            dt;
          res.data.data.forEach(item => {
            dt = date.setTime(item.timeStamp * 1000);
            item.timeStamp = date.Format("MM-dd HH:mm", dt);
          });
          this.kxrzList = res.data.data;
          this.logCount = Math.ceil(res.data.count / this.logLmit) || 0
          this.$loading_hide()
        });
      } else if (this.actionLog) {
        data.type = this.actionLog_type
        getData.postAxiosMethod("actionlog", data, res => {
          let date = new Date(),
            dt;
          res.data.data.forEach(item => {
            dt = date.setTime(item.timeStamp * 1000);
            item.timeStamp = date.Format("MM-dd HH:mm", dt);
          });
          this.kxrzList = res.data.data;
          this.logCount = Math.ceil(res.data.count / this.logLmit) || 0
          this.$loading_hide()
        });
      }
    },
    requestIssueReport() {
      let data = {};
      data.game_code = this.qbbGameCode || window.sessionStorage.getItem("code") || 'hn5fc';
      data.access_token = window.sessionStorage
        .getItem("login")
        .split("&")[0];
      data.uid = window.sessionStorage.getItem("login").split("&")[1];

      var time = new Date();
      let year = time.getFullYear()
      var month = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1);
      var day = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
      data.beforeDate = year + "-" + month + "-" + day

      getData.postAxiosMethod("issuereport", data, res => {
        this.qbbList = res.data.data;
      });
    },
    changeXzmxGame() {
      this.zxDetailNowPage = 1;
      this.getIssuelist(this.chooseDateToCompact(this.chooseDate));
    },
    oddsLogContent(list) {
      list = JSON.parse(list)
      let str = "<div>"
      list.forEach((item, index) => {
        str += `<span style="margin:0 5px; white-space: wrap;">${item.sonProject}:${item.orgBack}:${item.back}<span>`
        if ((index + 1) % 4 == 0) {
          str += '<br />'
        }
      })
      str += "</div>"
      return str
    },
    thirdBtnLog(log) {
      $(".game_loading_wrap").css({
        display: "block"
      });
      $(".game_item_warp").css({
        display: "none"
      });
      this.actionLog_type = "login"
      this.betLog_orderNum = ""
      this.betLog_type = ""
      this.betLog_playType = ""
      this.betLogGameCode = ""
      this.betLog = false
      this.actionLog = false;
      this[log] = true
      this.log_chooseDate = this.getBeforeDate(0)

      let data = {};
      data.access_token = window.sessionStorage
        .getItem("login")
        .split("&")[0];
      data.uid = window.sessionStorage.getItem("login").split("&")[1];

      data.beforeDate = this.log_chooseDate
      data.page = this.logNowPage
      data.limit = this.logLmit
      if (this.betLog) {
        if (this.betLogGameCode) {
          data.game_code = this.betLogGameCode
        }
        getData.postAxiosMethod("betlog", data, res => {
          let date = new Date(),
            dt;
          res.data.data.forEach(item => {
            dt = date.setTime(item.timeStamp * 1000);
            item.timeStamp = date.Format("MM-dd HH:mm", dt);
          });
          this.kxrzList = res.data.data;
          this.logCount = Math.ceil(res.data.count / this.logLmit) || 0
          $(".game_loading_wrap").css({
            display: "none"
          });
          $(".game_item_warp").css({
            display: "inline-block"
          });
        });
      } else if (this.actionLog) {
        data.type = this.actionLog_type
        getData.postAxiosMethod("actionlog", data, res => {
          let date = new Date(),
            dt;
          res.data.data.forEach(item => {
            dt = date.setTime(item.timeStamp * 1000);
            item.timeStamp = date.Format("MM-dd HH:mm", dt);
          });
          this.kxrzList = res.data.data;
          this.logCount = Math.ceil(res.data.count / this.logLmit) || 0
          $(".game_loading_wrap").css({
            display: "none"
          });
          $(".game_item_warp").css({
            display: "inline-block"
          });
        });
      }
    },
    betLogContent(list) {
      list = JSON.parse(list)
      let str = "<div>"
      list.forEach((item, index) => {
        str += `<span style="margin:0 5px; white-space: wrap;">${item.number}:${item.money}<span>`
        if ((index + 1) % 4 == 0) {
          str += '<br />'
        }
      })
      str += "</div>"
      return str
    },
    batchCharge() {
      if (this.orderNum.trim() == "") {
        G.alert({ content: "请输入注单编号!", ok: function () { return true; }, type: '1' });
        return
      }
      let _this = this
      G.alert({
        content: `${_this.orderNum} 订单号，确定退码吗`,
        ok: function () {
          let data = {
            access_token: window.sessionStorage.getItem("login").split("&")[0],
            uid: window.sessionStorage.getItem("login").split("&")[1],
            game_code: window.sessionStorage.getItem("code") || 'hn5fc',
            qihao: _this.chooseQihao,
            orderId: _this.orderNum
          }
          getData.postAxiosMethod('chargebackForOrderid', data, res => {
            G.alert({ content: res.data.msg, ok: function () { return true; }, type: '1' });
            _this.searchMx()
            _this.$event.$emit("updateUserInfo")
            _this.$emit('yzdData')
          })
          return true;
        },
        type: '1100'
      });

    },
    sum(list, key) {
      let sum = 0;
      list.forEach(item => {
        if (key == 'num') {
          console.log(item[key])
        }
        if (item && Object.prototype.hasOwnProperty.call(item, "ispei") && item.ispei != 1) {
          return;
        }
        if (item && Object.prototype.hasOwnProperty.call(item, "ispei")) {
          sum += ((item[key] ? item[key] : 0) * 1)
        } else if (item.winorlose || item.peie) {
          sum += (item[key] * 1)
        } else {
          sum += 0
        }

      })
      return sum || 0
    },
    reportSum(list, key) {
      return (list || []).reduce((total, item) => {
        if (item && Object.prototype.hasOwnProperty.call(item, "ispei") && item.ispei != 1) {
          return total;
        }
        return total + ((item && item[key] ? item[key] : 0) * 1);
      }, 0);
    },
    reportFirstValue(item, keys, fallback) {
      if (!item || typeof item !== "object") {
        return fallback === undefined ? 0 : fallback;
      }
      for (let i = 0; i < keys.length; i++) {
        const value = item[keys[i]];
        if (value !== undefined && value !== null && value !== "") {
          return value;
        }
      }
      return fallback === undefined ? 0 : fallback;
    },
    getDayReportBackValue(item) {
      return this.reportFirstValue(item, ["back", "backMoney", "rebateMoney", "waterMoney"], 0);
    },
    getDayReportBackTotal(list) {
      return (list || []).reduce((total, item) => {
        if (item && Object.prototype.hasOwnProperty.call(item, "ispei") && item.ispei != 1) {
          return total;
        }
        return total + (this.getDayReportBackValue(item) * 1 || 0);
      }, 0);
    },
    getSettlementReportDate(item) {
      return this.reportFirstValue(item, ["betDate", "date", "day", "settleDate"], "");
    },
    getSettlementReportDisplayDate(item) {
      return this.normalizeReportBetDate(this.getSettlementReportDate(item));
    },
    getSettlementReportValue(item, type) {
      if (type == "count") {
        return this.reportFirstValue(item, ["num", "issueNum", "count"], 0);
      }
      if (type == "money") {
        return this.reportFirstValue(item, ["betMoney", "money", "amount"], 0);
      }
      if (type == "back") {
        const back = this.reportFirstValue(item, ["backMoney", "back", "rebateMoney", "waterMoney"], null);
        if (back !== null) {
          return back;
        }
        const actualMoney = this.reportFirstValue(item, ["actualMoney"], null);
        const afterBackMoney = this.reportFirstValue(item, ["afterBackMoney"], null);
        if (actualMoney !== null && afterBackMoney !== null) {
          return (actualMoney * 1) - (afterBackMoney * 1);
        }
        return 0;
      }
      if (type == "draw") {
        return this.reportFirstValue(item, ["drawMoney", "draw", "winMoney", "afterBackMoney"], 0);
      }
      if (type == "profit") {
        return this.reportFirstValue(item, ["winorlose", "winOrLose", "profit", "actualMoney"], 0);
      }
      return 0;
    },
    getSettlementReportTotal(type) {
      return (this.dataList || []).reduce((total, item) => {
        return total + (this.getSettlementReportValue(item, type) * 1 || 0);
      }, 0);
    },
    formatReportNumber(value, keepDecimal = true) {
      const number = value * 1;
      if (isNaN(number)) {
        return "0";
      }
      if (!keepDecimal || number === 0) {
        return `${number}`;
      }
      return number.toFixed(2);
    },
    normalizeReportBetDate(value) {
      if (value === undefined || value === null || value === "") {
        return "";
      }
      const text = String(value).trim();
      if (!text) {
        return "";
      }
      if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
        return text;
      }
      if (/^\d{8}$/.test(text)) {
        return `${text.slice(0, 4)}-${text.slice(4, 6)}-${text.slice(6, 8)}`;
      }
      const normalized = text.replace(/\./g, "-").replace(/\//g, "-");
      const parsed = new Date(normalized);
      if (!Number.isNaN(parsed.getTime())) {
        const year = parsed.getFullYear();
        const month = `${parsed.getMonth() + 1}`.padStart(2, "0");
        const day = `${parsed.getDate()}`.padStart(2, "0");
        return `${year}-${month}-${day}`;
      }
      return text;
    },
    formatSettlementDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    getSettlementWeekRange(offset) {
      const now = new Date();
      const day = now.getDay() || 7;
      const monday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - day + 1 + (offset * 7));
      const sunday = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6);
      return {
        start: this.formatSettlementDate(monday),
        end: this.formatSettlementDate(sunday)
      };
    },
    getSettlementHalfMonthRange(offset) {
      const now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth();
      let half = now.getDate() <= 15 ? 1 : 2;
      half += offset;
      while (half <= 0) {
        half += 2;
        month -= 1;
      }
      while (half > 2) {
        half -= 2;
        month += 1;
      }
      const startDay = half == 1 ? 1 : 16;
      const endDay = half == 1 ? 15 : new Date(year, month + 1, 0).getDate();
      const start = new Date(year, month, startDay);
      const end = new Date(year, month, endDay);
      return {
        start: this.formatSettlementDate(start),
        end: this.formatSettlementDate(end)
      };
    },
    setSettlementRange(type, onlySetDate) {
      let range = null;
      if (type == "lastWeek") {
        range = this.getSettlementWeekRange(-1);
      } else if (type == "thisWeek") {
        range = this.getSettlementWeekRange(0);
      } else if (type == "lastHalfMonth") {
        range = this.getSettlementHalfMonthRange(-1);
      } else if (type == "thisHalfMonth") {
        range = this.getSettlementHalfMonthRange(0);
      }
      if (!range) {
        return;
      }
      this.reportRangeType = type;
      this.reportStartDate = range.start;
      this.reportEndDate = range.end;
      if (!onlySetDate) {
        this.requestSettlementReport();
      }
    },
    getReportGameData() {
      const data = {
        access_token: window.sessionStorage.getItem("login").split("&")[0],
        uid: window.sessionStorage.getItem("login").split("&")[1]
      };
      if (this.reportGameCode) {
        data.game_code = this.reportGameCode;
      }
      return data;
    },
    getReportGameCode(item) {
      if (!item || typeof item !== "object") {
        return "";
      }
      return item.gameCode || item.game_code || item.code || "";
    },
    getReportGameName(item) {
      if (!item || typeof item !== "object") {
        return sessionStorage.getItem("gameName");
      }
      const gameCode = this.getReportGameCode(item);
      const gameInfo = this.reportGameList.find(game => {
        return (game.code || game.gameCode || game.game_code || "") == gameCode;
      });
      if (gameInfo) {
        return gameInfo.gameName || gameInfo.menu || gameInfo.name || gameCode;
      }
      return item.gameName || gameCode || sessionStorage.getItem("gameName");
    },
    ensureReportGameList(callback) {
      if (this.reportGameList.length) {
        if (callback) {
          callback();
        }
        return;
      }
      const data = this.getReportGameData();
      getData.postAxiosMethod("gamelist", data, res => {
        this.reportGameList = Array.isArray(res.data.data) ? res.data.data : [];
        if (callback) {
          callback();
        }
      });
    },
    requestSettlementReport() {
      const data = this.getReportGameData();
      data.startDate = this.reportStartDate;
      data.endDate = this.reportEndDate;
      this.jsbb = true;
      this.$loading_show()
      getData.postAxiosMethod("report", data, res => {
        this.$loading_hide()
        this.dataList = Array.isArray(res.data.data) ? res.data.data : [];
        this.$nextTick(function () {
          $(".game_item_warp").css({
            display: "inline-block"
          });
        })
      });
    },
    reportDetail(item) {
      this.showIssueDetailCount = 5
      this.closeWin()
      this.$loading_show()
      const betDate = this.getSettlementReportDate(item);
      this.reportBetDate = this.normalizeReportBetDate(betDate);
      this.openReportDetail = Object.assign({}, item, {
        betDate: this.reportBetDate
      });
      const data = this.getReportGameData();
      data.betDate = betDate;
      this.ensureReportGameList(() => {
        getData.postAxiosMethod("dayReport", data, res => {
          this.$loading_hide()
          const detailData = res.data.data;
          const detailList = Array.isArray(detailData) ? detailData : (detailData ? [detailData] : []);
          this.openReportDetailList = detailList.map(detail => {
            const row = Object.assign({}, detail);
            row.betDate = row.betDate || this.reportBetDate;
            row.gameName = this.getReportGameName(row);
            return row;
          });
          if (!this.openReportDetail.gameName) {
            this.openReportDetail.gameName = this.getReportGameName(this.openReportDetail);
          }
          this.bbDetails = true
          this.$nextTick(function () {
            $(".game_item_warp").css({
              display: "inline-block"
            });
          })
        });
      });
    },
    backToReport() {
      this.closeWin()
      this.requestSettlementReport()
    },
    toIssueDetail(item) {
      if (item) {
        this.openReportDetail = Object.assign({}, item);
      }
      const beforeDate = this.reportBetDate || this.normalizeReportBetDate(this.openReportDetail.betDate)
      this.closeWin()
      this.$loading_show()
      const data = this.getReportGameData();
      data.game_code = this.openReportDetail.code || this.openReportDetail.game_code || this.openReportDetail.gameCode || window.sessionStorage.getItem("code") || 'hn5fc';
      data.beforeDate = beforeDate;
      setTimeout(() => {
        getData.postAxiosMethod("issuereport", data, res => {
          this.$loading_hide()
          this.issueDetailList = Array.isArray(res.data.data) ? res.data.data : [];
          this.issueDetail = true
          this.$nextTick(function () {
            $(".game_item_warp").css({
              display: "inline-block"
            });
          })
        });
      }, 300);
    },
    showMoreIssueDetail() {
      this.$loading_show()
      setTimeout(() => {
        this.$loading_hide()
        this.showIssueDetailCount += 5
      }, 500);
    },
    getXzmxStatusName(item) {
      if (!item) {
        return "-";
      }
      if (item.is_even == 1 && item.orderStatus == 1) {
        return "回本";
      }
      if ((item.peie * 1) == 0 && item.orderStatus == 1) {
        return "未中";
      }
      if ((item.peie * 1) != 0 && item.orderStatus == 1) {
        return "中奖";
      }
      if (item.orderStatus == 0) {
        return "成功";
      }
      if (item.orderStatus == 2) {
        return "退码";
      }
      if (item.orderStatus == 4) {
        return "撤回";
      }
      return "-";
    },
    getXzmxProfit(item) {
      if (!item || item.orderStatus == 0) {
        return "-";
      }
      const peie = parseFloat(item.peie) || 0;
      const back = parseFloat(item.back) || 0;
      const money = parseFloat(item.money) || 0;
      return (peie + back - money).toFixed(2);
    },
    getXzmxProfitTotal() {
      return (this.validXzmxList() || []).reduce((total, item) => {
        if (item.orderStatus == 0) {
          return total;
        }
        const peie = parseFloat(item.peie) || 0;
        const back = parseFloat(item.back) || 0;
        const money = parseFloat(item.money) || 0;
        return total + peie + back - money;
      }, 0).toFixed(2);
    },
    validXzmxList() {
      return this.xzmxList.filter(function (item) {
        return item.orderStatus != 2;
      });
    },
    logFirstPage() {
      this.logNowPage = 1
    },
    logPrevious() {
      if (this.logNowPage > 1) {
        this.logNowPage--
      }
    },
    logNext() {
      if (this.logNowPage < this.logCount) {
        this.logNowPage++
      }
    },
    logLastPage() {
      this.logNowPage = this.logCount
    },
    zxFirstPage() {
      this.zxDetailNowPage = 1
    },
    zxPrevious() {
      console.log(this.zxDetailNowPag > 1)
      if (this.zxDetailNowPage > 1) {
        this.zxDetailNowPage--
      }
    },
    zxNext() {
      if (this.zxDetailNowPage < this.zxDetailCount) {
        this.zxDetailNowPage++
      }
    },
    zxLastPage() {
      this.zxDetailNowPage = this.zxDetailCount
    },
    zxChargeback() {
      let _this = this
      let orderSubIds = []
      this.xzmxList.forEach(item => {
        if (item.checked && item.orderStatus != 2) {
          orderSubIds.push(item.orderSubId)
        }
      })
      orderSubIds = orderSubIds.join(",")
      if (orderSubIds !== '') {
        let data = {
          access_token: window.sessionStorage.getItem("login").split("&")[0],
          uid: window.sessionStorage.getItem("login").split("&")[1],
          game_code: window.sessionStorage.getItem("code") || 'hn5fc',
          qihao: this.chooseQihao,
          orderSubIds,
        }
        this.$loading_show()
        getData.postAxiosMethod('chargeback', data, res => {
          G.alert({ content: res.data.msg, ok: function () { return true; }, type: '1' });
          _this.searchMx()
          _this.$event.$emit("updateUserInfo")
          this.$emit('yzdData')
        })
      }
    },
    kdChargeback() {
      let orderSubIds = []
      this.kdList.slice(0, 10).forEach(item => {
        if (item.checked) {
          orderSubIds.push(item.orderSubId)
        }
      })
      orderSubIds = orderSubIds.join(",")
      if (orderSubIds !== '') {
        let data = {
          access_token: window.sessionStorage.getItem("login").split("&")[0],
          uid: window.sessionStorage.getItem("login").split("&")[1],
          game_code: window.sessionStorage.getItem("code") || 'hn5fc',
          qihao: window.sessionStorage.getItem("qiNum"),
          orderSubIds,
        }
        this.$loading_show()
        getData.postAxiosMethod('chargeback', data, res => {
          G.alert({ content: res.data.msg, ok: function () { return true; }, type: '1' });
          this.$event.$emit("updateUserInfo")
          this.$emit('yzdData')
          let data2 = {};
          data2.access_token = window.sessionStorage
            .getItem("login")
            .split("&")[0];
          data2.uid = window.sessionStorage.getItem("login").split("&")[1];
          data2.game_code = window.sessionStorage.getItem("code");
          data2.play_type = "kuaida";
          getData.postAxiosMethod("currentissuebetlist", data2, res => {
            this.$loading_hide()
            this.kdList = res.data.data;
          });
        })
      }
    },
    getIssuelist(date, qNum = "") {
      let data = {
        access_token: window.sessionStorage.getItem("login").split("&")[0],
        uid: window.sessionStorage.getItem("login").split("&")[1],
        game_code: this.xzmxGameCode || window.sessionStorage.getItem("code") || 'hn5fc',
        date
      }
      getData.postAxiosMethod("bet/issuelist", data, res => {
        this.issuelist = res.data.data
        const targetQihao = qNum != "" ? qNum : this.issuelist[0];
        if (this.chooseQihao == targetQihao) {
          this.searchMx()
        } else {
          this.chooseQihao = targetQihao
        }
      })
    },
    djsFp(type) {
      let typeNum = $("#numNavList")
        .find(".subBtn.active a")
        .html();
      if (!typeNum) {
        typeNum = this.tempTitle || (this.subNavList[0] && this.subNavList[0].title);
      }
      // if (type == "开奖") {
      this.changeRoute(typeNum, true);
      // }
    },
    changTxt() {
      uploadfile(this);
      $("#tool_ys_input").keyup(function () {
        //$(this).val($(this).val().replace(/[^0-9]/g, ''));
        G.clearNoNum($(this));
        var bishu = $("#zbishu").html();
        if (bishu.length > 0 && $(this).val().length > 0) {
          $("#zmoney").html(parseInt(bishu) * parseFloat($(this).val()));
        } else {
          $("#zmoney").html("");
        }
      });
    },
    yzdHd() {
      const _this = this;
      let typeNum = $("#numNavList")
        .find(".subBtn.active a")
        .html();
      setTimeout(() => {
        if (document.getElementsByClassName(
          "btn hotBtn myLayerOk"
        )[0]) {
          document.getElementsByClassName(
            "btn hotBtn myLayerOk"
          )[0].onclick = function () {
            if (typeNum == "一字定" || typeNum == "两面" || typeNum == "番摊") {
              _this.$emit("yzdData", 1);
            } else {
              _this.$emit("yzdData", 2);
            }
          };
        } else {
          G.alert({ content: "请先选择号码", ok: function () { return true; }, type: '1' });
        }
      }, 300);
    },
    chooseCheckBox() {
      this.check = !this.check;
      this.xzmxList.forEach(item => {
        if (item.orderStatus !== 2) {
          item.checked = this.check
        }
      })
    },
    xzmxTz(qNum) {
      this.qbb = false;
      this.zxdetails = true;
      this.qbbToZxdetail = true
      this.orderNum = ""
      this.zxDetailNowPage = 1
      this.xzmxGameCode = this.qbbGameCode || window.sessionStorage.getItem("code") || 'hn5fc'
      setTimeout(() => {
        $(".game_loading_wrap").css("display", "none");
      }, 100);
      this.getIssuelist("", qNum)
    },
    getQihao(yesterdayNum) {
      var time = new Date().getTime() - 24 * yesterdayNum * 60 * 60 * 1000;
      var yesterday = new Date(time);
      var month = yesterday.getMonth();
      var day = yesterday.getDate();
      yesterday =
        yesterday.getFullYear() +
        (yesterday.getMonth() > 9
          ? yesterday.getMonth() + 1
          : "0" + parseInt(yesterday.getMonth() + 1)) +
        (yesterday.getDate() > 9
          ? yesterday.getDate()
          : "0" + yesterday.getDate());
      return yesterday;
    },
    getBeforeDate(yesterdayNum) {
      var time = new Date().getTime() - 24 * yesterdayNum * 60 * 60 * 1000;
      var yesterday = new Date(time);
      var month = yesterday.getMonth();
      var day = yesterday.getDate();
      yesterday =
        yesterday.getFullYear() +
        "-" +
        (yesterday.getMonth() > 9
          ? yesterday.getMonth() + 1
          : yesterday.getMonth() + 1) +
        "-" +
        (yesterday.getDate() > 9 ? yesterday.getDate() : yesterday.getDate());
      return yesterday;
    },
    chooseDateToCompact(dateText) {
      const dateArr = (dateText || "").split("-");
      if (dateArr.length != 3) {
        return "";
      }
      const year = dateArr[0];
      const month = (dateArr[1] * 1) > 9 ? dateArr[1] : "0" + dateArr[1];
      const day = (dateArr[2] * 1) > 9 ? dateArr[2] : "0" + dateArr[2];
      return year + month + day;
    },
    getLocalTime(nS) {
      let time = new Date(parseInt(nS) * 1000)
        .toLocaleString()
        .replace(/\//g, "-");
      if (time.includes("下午")) {
        time = time.replace(
          /上午|下午\d/g,
          12 + parseInt(time[time.indexOf("下午") + 2])
        );
      } else {
        time = time.replace(/上午|下午/g, " ");
      }
      return time;
    },
    searchMx() {
      // this.qbbDetailQh = ""
      let data = {};
      data.access_token = window.sessionStorage.getItem("login").split("&")[0];
      data.uid = window.sessionStorage.getItem("login").split("&")[1];
      data.game_code = this.xzmxGameCode || window.sessionStorage.getItem("code") || 'hn5fc';
      if (this.chooseQihao == "全部") {
        data.qihao = "";
      } else {
        data.qihao = this.chooseQihao;
      }

      const fromIssueReport = this.qbbToZxdetail;
      data.beforeDate = fromIssueReport ? "" : this.chooseDateToCompact(this.chooseDate);
      if (fromIssueReport) {
        this.qbbToZxdetail = false;
      }
      data.page = this.zxDetailNowPage
      data.limit = this.zxDetailLmit
      this.chooseDate.split("-")[0] + this.chooseDate.split("-")[1] > 9
        ? this.chooseDate.split("-")[1]
        : "0" + this.chooseDate.split("-")[1] + this.chooseDate.split("-")[2] >
          9
          ? this.chooseDate.split("-")[2]
          : "0" + this.chooseDate.split("-")[2];
      let ztm = this.ztm
      if (ztm == -1) {
        data.orderStatus = ""
      } else {
        data.orderStatus = ztm;
      }
      data.orderId = this.orderNum;
      // this.zxdetails = true;
      this.$loading_show()
      setTimeout(() => {
        getData.postAxiosMethod("bet/betlist", data, res => {
          res.data.data.forEach(item => {
            item.betTime = this.getLocalTime(item.betTime);
            if (item.chargebackTime != 0) {
              item.chargebackTime = this.getLocalTime(item.chargebackTime);
            }
          });
          this.xzmxList = res.data.data;
          // this.zxDetailNowPage = 1
          this.zxDetailCount = Math.ceil(res.data.count / this.zxDetailLmit) || 0
          this.$loading_hide()
        });
      }, 300)
    },
    changeEzdNav(index) {
      $(".game_loading_wrap").css({
        display: "block"
      });
      $(".game_item_warp").css({
        display: "none"
      });
      this.selectedIndex = index;
      this.refreshEzdChangeSubNavList();
      setTimeout(() => {
        $(".game_loading_wrap").css({
          display: "none"
        });
        $(".game_item_warp").css({
          display: "inline-block"
        });
      }, 500)
    },
    normalizeEzdNumber(number) {
      number = String(number || "").toUpperCase();
      if (number.length == 4) {
        number = number + "X";
      }
      return number;
    },
    currentEzdProject() {
      return this.ezdSubNavList[this.selectedIndex] || {};
    },
    currentEzdTitle() {
      return this.currentEzdProject().title || "";
    },
    currentEzdPosName(index) {
      const pos = this.currentEzdProject().pos_str || [];
      return pos[index] || "";
    },
    currentEzdPosLabel(index) {
      const name = this.currentEzdPosName(index);
      return name ? name + "位" : "";
    },
    getEzdSortByNumber(number) {
      number = this.normalizeEzdNumber(number);
      if (/^\d{2}XXX$/.test(number)) {
        return 108 + parseInt(number[0]) * 10 + parseInt(number[1]);
      } else if (/^\dX\dXX$/.test(number)) {
        return 208 + parseInt(number[0]) * 10 + parseInt(number[2]);
      } else if (/^\dXX\dX$/.test(number)) {
        return 308 + parseInt(number[0]) * 10 + parseInt(number[3]);
      } else if (/^\dXXX\d$/.test(number)) {
        return 408 + parseInt(number[0]) * 10 + parseInt(number[4]);
      } else if (/^X\d{2}XX$/.test(number)) {
        return 508 + parseInt(number[1]) * 10 + parseInt(number[2]);
      } else if (/^X\dX\dX$/.test(number)) {
        return 608 + parseInt(number[1]) * 10 + parseInt(number[3]);
      } else if (/^X\dXX\d$/.test(number)) {
        return 708 + parseInt(number[1]) * 10 + parseInt(number[4]);
      } else if (/^XX\d{2}X$/.test(number)) {
        return 808 + parseInt(number[2]) * 10 + parseInt(number[3]);
      } else if (/^XX\dX\d$/.test(number)) {
        return 908 + parseInt(number[2]) * 10 + parseInt(number[4]);
      } else if (/^XXX\d\d$/.test(number)) {
        return 1008 + parseInt(number[3]) * 10 + parseInt(number[4]);
      }
      return 0;
    },
    createEzdNumber(title, first, second) {
      title = this.normalizeEzdNumber(title);
      let count = 0;
      let number = "";
      for (let i = 0; i < title.length; i++) {
        if (title[i] == "口") {
          number += count == 0 ? first : second;
          count++;
        } else {
          number += title[i];
        }
      }
      return count == 2 ? number : "";
    },
    refreshEzdChangeSubNavList() {
      const project = this.currentEzdProject();
      const title = project.title || "";
      const oddsMap = {};
      this.ballListD2W.forEach(item => {
        oddsMap[this.normalizeEzdNumber(item.number)] = item;
      });
      const list = [];
      for (let first = 0; first <= 9; first++) {
        for (let second = 0; second <= 9; second++) {
          const number = this.createEzdNumber(title, String(first), String(second));
          if (!number) {
            continue;
          }
          const matched = oddsMap[this.normalizeEzdNumber(number)] || {};
          const item = Object.assign({}, matched, {
            number: matched.number || number,
            peilv: matched.peilv === undefined ? "-" : matched.peilv,
            __sort: this.getEzdSortByNumber(number)
          });
          list.push(item);
        }
      }
      this.ezdChangeSubNavList = list;
    },
    cancleWin() {
      this.createTj = false;
    },
    kdtj() {
      const _this = this;
      kdjstj(data2 => {
        // if (data.length < 10) {
        //   for (let i = 0; i < 10 - data.length; i++) {
        //     let obj = {};
        //     obj.back = "-";
        //     obj.betNumber = "-";
        //     obj.betTime = "-";
        //     obj.gameCode = "-";
        //     obj.ispei = "-";
        //     obj.money = "-";
        //     obj.orderId = "-";
        //     obj.peilv = "-";
        //     obj.playCode = "-";
        //     data.push(obj);
        //   }
        // }
        // _this.kdList = data;
        let data = {};
        data.access_token = window.sessionStorage
          .getItem("login")
          .split("&")[0];
        data.uid = window.sessionStorage.getItem("login").split("&")[1];
        data.game_code = window.sessionStorage.getItem("code");
        data.play_type = "kuaida";
        getData.postAxiosMethod("currentissuebetlist", data, res => {
          _this.kdList = res.data.data;
        })
        _this.$emit("yzdData", 3);
      });
    },
    closeWin() {
      this.zxdetails = false;
      this.createTj = false;
      this.lm = false;
      this.ft = false;
      this.yzd = false;
      this.ezd = false;
      this.kd = false;
      this.kx = false;
      this.txtdr = false;
      this.qbb = false;
      this.jsbb = false;
      this.bbDetails = false;
      this.issueDetail = false;
      this.kxrz = false;
      this.hewfx = false;
      this.betLog = false;
      this.actionLog = false;
    },
    test(res) {
    },
    updateOdds() {
      this.getD1WOdds();
      this.getD2WOdds();
    },
    getD1WOdds() {
      let dataObj = {};
      dataObj.access_token = window.sessionStorage
        .getItem("login")
        .split("&")[0];
      dataObj.uid = window.sessionStorage.getItem("login").split("&")[1];
      dataObj.code = window.sessionStorage.getItem("code");
      dataObj.playcode = "D1W";
      getData.postAxiosMethod("odds/odds", dataObj, res => {
        if (window.sessionStorage.getItem("isClose") == "0") {
          this.ballListD1W = res.data.data;
          setTimeout(() => {
            $(".game_box_zhixuan").find('input').attr('disabled', null)
          }, 500)
        } else {
          res.data.data.forEach((item, index) => {
            res.data.data[index].peilv = "-";
            setTimeout(() => {
              $(".game_box_zhixuan").find('input').attr('disabled', 'disabled')
            }, 500)

          });
          this.ballListD1W = res.data.data;
        }
      });
    },
    getD2WOdds() {
      let dataObj = {};

      dataObj.access_token = window.sessionStorage
        .getItem("login")
        .split("&")[0];
      dataObj.uid = window.sessionStorage.getItem("login").split("&")[1];
      dataObj.code = window.sessionStorage.getItem("code");
      dataObj.playcode = "D2W";
      getData.postAxiosMethod("odds/odds", dataObj, res => {
        if (window.sessionStorage.getItem("isClose") == "0") {
          this.test(res)
          this.ballListD2W = res.data.data;
          this.refreshEzdChangeSubNavList();
          setTimeout(() => {
            $(".game_box_zhixuan").find('input').attr('disabled', null)
          }, 500);
        } else {
          res.data.data.forEach((item, index) => {
            res.data.data[index].peilv = "-";
            setTimeout(() => {
              $(".game_box_zhixuan").find('input').attr('disabled', 'disabled')
            }, 500);
          });
          this.ballListD2W = res.data.data;
          this.refreshEzdChangeSubNavList();
        }
      });
    },
    changeRoute(title, notNeedHidenBox) {
      let _this = this
      if (!this.isSubNavVisible(title)) {
        const firstNav = this.subNavList[0] && this.subNavList[0].title;
        if (firstNav && firstNav != title) {
          this.changeRoute(firstNav, notNeedHidenBox);
          return;
        }
        this.closeWin();
        this.tempTitle = "";
        this.tabIndex = -1;
        return;
      }
      this.tempTitle = title;
      this.tabIndex = this.getSubNavIndex(title);
      if (!notNeedHidenBox) {
        $(".game_item_warp").css({
          display: "none"
        });
        $("#rightBox").hide()
      }
      $("#tool_ys_input").attr('disabled', false)
      if (title == "两面") {
        this.tabIndex = this.getSubNavIndex("两面");
        this.closeWin();
        this.lm = true;
        this.getLMOdds();
      } else if (title == "番摊") {
        this.tabIndex = this.getSubNavIndex("番摊");
        this.closeWin();
        this.ft = true;
        this.getFTOdds();
      } else if (title == "一字定") {
        this.tabIndex = this.getSubNavIndex("一字定");
        this.closeWin();
        this.yzd = true;
        $('#tool_ys_input').val("")
        setTimeout(() => {
          bindGameFun(_this);
        }, 0);
        let dataObj = {};
        dataObj.access_token = window.sessionStorage
          .getItem("login")
          .split("&")[0];
        dataObj.uid = window.sessionStorage.getItem("login").split("&")[1];
        dataObj.code = window.sessionStorage.getItem("code");
        dataObj.playcode = "D1W";
        getData.postAxiosMethod("odds/odds", dataObj, res => {
          if (window.sessionStorage.getItem("isClose") == "0") {
            this.ballListD1W = res.data.data;
            setTimeout(() => {
              $(".game_box_zhixuan").find('input').attr('disabled', null)
            }, 500)
          } else {
            res.data.data.forEach((item, index) => {
              res.data.data[index].peilv = "-";
              setTimeout(() => {
                $(".game_box_zhixuan").find('input').attr('disabled', 'disabled')
              }, 500)

            });
            this.ballListD1W = res.data.data;
          }
          $(".game_loading_wrap").css({
            display: "none"
          });
          $(".game_item_warp").css({
            display: "inline-block"
          });
        });
        this.$emit("yzdData", 1);
      } else if (title == "二字定") {
        const post_data = {
          'access_token': window.sessionStorage
            .getItem("login")
            .split("&")[0],
          'uid': window.sessionStorage.getItem("login").split("&")[1],
          'game_code': window.sessionStorage.getItem("code"),
          'play_code': 'D2W'
        }
        this.tabIndex = this.getSubNavIndex("二字定");
        this.closeWin();
        this.ezd = true;
        this.selectedIndex = 0
        getData.postAxiosMethod("game/sonProject", post_data, res => {
          this.ezdSubNavList = res.data.data
          let dataObj = {};
          dataObj.access_token = window.sessionStorage
            .getItem("login")
            .split("&")[0];
          dataObj.uid = window.sessionStorage.getItem("login").split("&")[1];
          dataObj.code = window.sessionStorage.getItem("code");
          dataObj.playcode = "D2W";
          getData.postAxiosMethod("odds/odds", dataObj, res => {
            if (window.sessionStorage.getItem("isClose") == "0") {
              this.ballListD2W = res.data.data;
              this.refreshEzdChangeSubNavList();
              setTimeout(() => {
                $(".game_box_zhixuan").find('input').attr('disabled', null)
              }, 500);
            } else {
              res.data.data.forEach((item, index) => {
                res.data.data[index].peilv = "-";
                setTimeout(() => {
                  $(".game_box_zhixuan").find('input').attr('disabled', 'disabled')
                }, 500);
              });
              this.ballListD2W = res.data.data;
              this.refreshEzdChangeSubNavList();
            }
            $(".game_loading_wrap").css({
              display: "none"
            });
            $(".game_item_warp").css({
              display: "inline-block"
            });
            this.$nextTick(function () {
              bindGameFun(this);
              // $(".myLayer").css({
              //   top: "unset",
              //   left: "unset"
              // });
              this.$emit("yzdData", 2);
            })
          });

        })
        return



      } else if (title == "快打") {
        this.tabIndex = this.getSubNavIndex("快打");
        this.closeWin();
        setTimeout(() => {
          kd();
        }, 0);
        let data = {};
        data.access_token = window.sessionStorage
          .getItem("login")
          .split("&")[0];
        data.uid = window.sessionStorage.getItem("login").split("&")[1];
        data.game_code = window.sessionStorage.getItem("code");
        data.play_type = "kuaida";
        getData.postAxiosMethod("currentissuebetlist", data, res => {
          this.kdList = res.data.data;
          $(".game_loading_wrap").css({
            display: "none"
          });
          $(".game_item_warp").css({
            display: "inline-block"
          });
        });
        this.kd = true;
        this.$emit("yzdData", 3);
      } else if (title == "快选") {
        this.tabIndex = this.getSubNavIndex("快选");
        let beforeNum = 0
        if (this.kx) {
          beforeNum = $('#kuaixianList').find('.active a').attr('data-action')
        }
        this.closeWin();
        this.kx = true;
        createNum(this);
        setTimeout(() => {
          if (beforeNum != 0) {
            kxcontent(beforeNum * 1, _this);
          } else {
            kxcontent(2, _this);
          }
        }, 0);
        setTimeout(() => {
          $("#rightBox").show()
          $(".game_loading_wrap").css({
            display: "none"
          });
          $(".game_item_warp").css({
            display: "inline-block"
          });
        }, 300)
        this.$emit("yzdData", 4);
      } else if (title == "txt导入") {
        setTimeout(() => {
          $(".game_loading_wrap").css({
            display: "none"
          });
          $(".game_item_warp").css({
            display: "inline-block"
          });
        }, 300)
        this.tabIndex = this.getSubNavIndex("txt导入");
        this.closeWin();
        this.txtdr = true;

      } else {
        setTimeout(() => {
          $(".game_loading_wrap").css({
            display: "none"
          });
          $(".game_item_warp").css({
            display: "inline-block"
          });
        }, 300)
      }
      // bindGameFun();
    },
    changeSubNavList(node, index) {
      this.indexTab = index;
    },
    changeContainer(title) {
      $(".game_item_warp").css({
        display: "none"
      });
      this.closeWin();
      const _this = this;

      if (title == "下注明细") {
        this.removeTabIndex()
        this.chooseDate = this.getBeforeDate(0);
        this.xzmxGameCode = window.sessionStorage.getItem("code") || 'hn5fc';
        this.xzDate = [];
        for (let i = 0; i < 14; i++) {
          let obj = {};
          obj.date = this.getBeforeDate(i);

          this.xzDate.push(obj);
        }
        this.ztm = -1
        let data = {};
        data.access_token = window.sessionStorage
          .getItem("login")
          .split("&")[0];
        data.uid = window.sessionStorage.getItem("login").split("&")[1];
        data.code = window.sessionStorage.getItem("code") || 'hn5fc';
        let year = this.chooseDate.split("-")[0];
        let month =
          this.chooseDate.split("-")[1] > 9
            ? this.chooseDate.split("-")[1]
            : "0" + this.chooseDate.split("-")[1];
        let day =
          this.chooseDate.split("-")[2] > 9
            ? this.chooseDate.split("-")[2]
            : "0" + this.chooseDate.split("-")[2];
        data.beforeDate = year + month + day;
        if (this.ztm == -1) {
          data.orderStatus = ""
        } else {
          data.orderStatus = this.ztm;
        }
        data.orderId = "";
        getData.postAxiosMethod("gamelist", data, res => {
          _this.menuList = [];
          res.data.data.forEach(res => {
            let obj = {};
            obj.menu = res.gameName;
            obj.code = res.code;
            _this.menuList.push(obj);
          });
        });

        this.zxdetails = true;
        this.orderNum = ""
        this.zxDetailNowPage = 1
        data.page = this.zxDetailNowPage
        data.limit = this.zxDetailLmit
        this.getIssuelist(data.beforeDate)

      } else if (title == "结算报表") {
        this.removeTabIndex()
        this.reportGameCode = "";
        this.setSettlementRange("thisWeek", true);
        this.requestSettlementReport();
        this.ensureReportGameList();
      } else if (title == "期期报表") {
        this.removeTabIndex()
        this.qbb = true;
        this.qbbGameCode = window.sessionStorage.getItem("code") || 'hn5fc';
        let data = {};
        data.access_token = window.sessionStorage
          .getItem("login")
          .split("&")[0];
        data.uid = window.sessionStorage.getItem("login").split("&")[1];
        this.requestIssueReport();
        getData.postAxiosMethod("gamelist", data, res => {
          _this.menuList = [];
          res.data.data.forEach(res => {
            let obj = {};
            obj.menu = res.gameName;
            obj.code = res.code;
            _this.menuList.push(obj);
          });
        });
      } else if (title == window.sessionStorage.getItem("gameName")) {
        this.removeTabIndex()
        this.zxdetails = true;
        this.orderNum = ""
      } else {
        this.removeTabIndex()
        this.log_chooseDate = this.getBeforeDate(0);
        this.betLog_orderNum = ""
        this.betLog_type = ""
        this.betLog_playType = ""
        this.betLogGameCode = ""
        this.actionLog_type = "login"


        let data = {};
        data.access_token = window.sessionStorage
          .getItem("login")
          .split("&")[0];
        data.uid = window.sessionStorage.getItem("login").split("&")[1];
        // data.type = "moneychange";
        // data.play_code = this.betLog_type
        // data.play_type = ""
        this.logNowPage = 1
        data.beforeDate = this.log_chooseDate
        data.type = this.actionLog_type
        data.page = this.logNowPage
        data.limit = this.logLmit

        getData.postAxiosMethod("actionlog", data, res => {
          let date = new Date(),
            dt;
          res.data.data.forEach(item => {
            dt = date.setTime(item.timeStamp * 1000);
            item.timeStamp = date.Format("MM-dd HH:mm", dt);
          });
          this.kxrzList = res.data.data;
          this.logCount = Math.ceil(res.data.count / this.logLmit) || 0
          $(".game_loading_wrap").css({
            display: "none"
          });
          $(".game_item_warp").css({
            display: "inline-block"
          });
        });
        // getData.postAxiosMethod("actionlog", data, res => {
        //   let date = new Date(),
        //     dt;
        //   res.data.data.forEach(item => {
        //     dt = date.setTime(item.timeStamp * 1000);
        //     item.timeStamp = date.Format("MM-dd HH:mm", dt);
        //   });
        //   this.kxrzList = res.data.data;
        //   this.logCount =  Math.ceil(res.data.count / this.logLmit) || 0
        // });
        getData.postAxiosMethod("gamelist", data, res => {
          _this.menuList = [];
          res.data.data.forEach(res => {
            let obj = {};
            obj.menu = res.gameName;
            obj.code = res.code;
            _this.menuList.push(obj);
          });
        });

        this.kxrz = true;
        this.actionLog = true
        this.betLog = false
      }

      setTimeout(() => {
        $(".game_loading_wrap").css({
          display: "none"
        });
        $(".game_item_warp").css({
          display: "inline-block"
        });
      }, 300);
    },
    createNumber() {
      $("#kx_content input[name='create-number']").click()
    },
  }
};
</script>
<style>
.gameLeft {
  width: auto !important;
}

.game_item_warp {
  display: none;
}

.game_loading_wrap {
  width: 100%;
}

.blank_play_page {
  min-height: 420px;
}

.settlement-report-table {
  table-layout: fixed;
}

.settlement-report-table th,
.settlement-report-table td {
  border: 1px solid #d9d9d9;
  height: 22px;
  line-height: 22px;
  padding: 0 8px !important;
  font-weight: bold;
}

.settlement-report-table .date-col {
  width: 46%;
  background: #eeeeee;
  text-align: center;
}

.settlement-report-table .amount-col {
  width: 10.8%;
  background: #ffcc66;
  text-align: center;
}

.settlement-report-table .date-col a {
  color: #1d2fc5;
  text-decoration: underline;
}

.settlement-report-table .settlement-total-row td {
  background: #c7ffe8;
}

.ft_box_con .game_item_warp {
  width: 875px;
  overflow: hidden;
}

.fant-page {
  width: 858px;
  margin: 0 auto;
}

.ft_table,
.ft_inner_table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
}

.ft_table td,
.ft_inner_table td {
  border-color: #d8d8d8;
  height: 74px;
  text-align: center;
  vertical-align: middle;
}

.ft_table li,
.ft_inner_table li {
  list-style: none;
}

.ft_cell .name,
.ft_inner_table .name {
  display: inline-block;
  color: #333;
  line-height: 18px;
  font-size: 12px;
  white-space: nowrap;
}

.ft_cell .p a,
.ft_inner_table .p a {
  color: #e64100;
  line-height: 18px;
  font-size: 12px;
  font-weight: bold;
  font-family: Verdana, "ثخجه", Arial, Sans;
}

.ft_cell .input,
.ft_inner_table .input {
  width: 44px;
  height: 18px;
  margin-top: 3px;
  text-align: center;
}

.ft_cell.men {
  background: #fff8ee;
}

.ft_cell.tong {
  background: #f7fbff;
}

.ft_cell.jiao {
  background: #fff4f4;
}

.ft_cell.zheng {
  background: #f4fff2;
}

.ft_cell.nian {
  background: #f5f0ff;
}

.ft_cell.fan {
  background: #fff7dc;
}

.ft_cell.dxds {
  background: #eef9ff;
}

.ft_center_cell {
  padding: 0;
}

.ft_center {
  display: flex;
}

.ft_center_item {
  width: 50%;
  min-width: 0;
  padding: 2px 0;
}

.wwrdPnode {
  display: inline;
}

#kx_content {
  overflow: unset;
  height: 414px;
}

#myWarpr {
  position: absolute;
  top: 0;
  min-width: 1150px;
  width: 100%;
  height: 100vh;
}

.charge td {
  background-color: rgb(255, 193, 132) !important;
}
</style>
